(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4111],{

/***/ 35266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/banner-arrow.cfa577cc.png","height":128,"width":127,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcElEQVR42mPQ2K5xXOOYhj4DgyYzAwhocAKxu8ZJDUEgzcgAAxq9Gv5AkhUspFmusVTjrsYymFyyxkGNPM0LGi0apzR5gBo1lDSWa6zR0ACqjNaYpzELYYqLRo7mHY2jDBpMmowgCzWENDI1bmhMBwA9thlJOT/Q6QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 96836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/logo.0a53d968.svg","height":27,"width":204});

/***/ }),

/***/ 89203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ webHeader)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/index.js + 5 modules
var navVipEntrance = __webpack_require__(5453);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js + 17 modules
var teamInfo = __webpack_require__(77646);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var types_teamInfo = __webpack_require__(32485);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./src/utils/login.ts + 1 modules
var login = __webpack_require__(37733);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(32711);
;// CONCATENATED MODULE: ./src/components/userInfo/index.tsx
"use client";






const UserInfo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(7969), __webpack_require__.e(746), __webpack_require__.e(1271), __webpack_require__.e(9319), __webpack_require__.e(7381), __webpack_require__.e(5107), __webpack_require__.e(553)]).then(__webpack_require__.bind(__webpack_require__, 97761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97761)
            ]
    },
    ssr: false
});
const User = (param)=>{
    let { userInfo , meidouInfo , cutoutInfo  } = param;
    const [callback, setCallback] = (0,react.useState)("");
    const handleOpenVip = ()=>{
        var ref;
        (0,login/* openVipModal */.C2)({
            entrance: "open",
            subscribe_type: ((ref = (0,lib/* getLocalIdentity */.u5)()) === null || ref === void 0 ? void 0 : ref.oid) ? "subscription" : undefined
        });
    };
    (0,react.useEffect)(()=>{
        setCallback((0,login/* getCallback */.RN)());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo, {
        userInfo: userInfo,
        callback: callback,
        avatarSize: 34,
        meidouAmount: meidouInfo === null || meidouInfo === void 0 ? void 0 : meidouInfo.available_amount,
        cutoutAmount: cutoutInfo === null || cutoutInfo === void 0 ? void 0 : cutoutInfo.left,
        onLogin: login/* jumpToLogin */.lU,
        onLogout: login/* handleLogout */.hY,
        onOpenVipModal: handleOpenVip,
        track: mtstat/* statTrack */.SF,
        onExchangeSuccess: login/* getUserInfo */.bG
    });
};
/* harmony default export */ const components_userInfo = (/*#__PURE__*/react.memo(User));

;// CONCATENATED MODULE: ./src/components/teamInfo/index.tsx





function TeamInfo(param) {
    let { userInfo  } = param;
    const handleOpenVip = function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,login/* openVipModal */.C2)(params);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teamInfo/* TeamInfoModal */.kK, {
            uid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || 0,
            onChange: ()=>{
                window.location.reload();
            },
            onOpenVipModal: (params)=>{
                handleOpenVip(params);
            },
            onTrack: mtstat/* statTrack */.SF
        })
    });
}
/* harmony default export */ const components_teamInfo = (/*#__PURE__*/react.memo(TeamInfo));

// EXTERNAL MODULE: ./src/assets/images/logo.svg
var logo = __webpack_require__(96836);
// EXTERNAL MODULE: ./src/hooks/useUserHelper.ts
var useUserHelper = __webpack_require__(62893);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logo/index.js + 2 modules
var dist_logo = __webpack_require__(41462);
// EXTERNAL MODULE: ./src/components/webHeader/index.module.css
var index_module = __webpack_require__(4047);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/index.js
var dist = __webpack_require__(98638);
// EXTERNAL MODULE: ./src/utils/event.ts
var utils_event = __webpack_require__(26870);
// EXTERNAL MODULE: ./src/constants/event.ts
var constants_event = __webpack_require__(98442);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./src/components/webHeader/index.tsx




















const MeidouInfo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(7969), __webpack_require__.e(746), __webpack_require__.e(1271), __webpack_require__.e(4119), __webpack_require__.e(7381), __webpack_require__.e(3954)]).then(__webpack_require__.bind(__webpack_require__, 28555)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(28555)
            ]
    },
    ssr: false
});
const WebHeader = (props)=>{
    var ref;
    const { isPersonal , onCreate , isWorkSpace =false  } = props;
    const userInfo = (0,useUserHelper/* useGetUserInfo */.Jh)();
    const meidouInfo = (0,useUserHelper/* useGetMeidouInfo */.nr)();
    const cutoutInfo = (0,useUserHelper/* useGetCutoutInfo */.rC)();
    const currentIdentity = (0,teamInfo/* useCurrentTeamIdentity */.q5)();
    const [headerStyle, setHeaderStyle] = (0,react.useState)({});
    const isOpenPptCommercialization = (0,store/* useStoreState */.Kw)((state)=>state.isOpenPptCommercialization);
    const isWidgetsConfigDone = (0,store/* useStoreState */.Kw)((state)=>state.isWidgetsConfigDone);
    const handleOpenVip = (params, closeCallback, payCallback)=>{
        !isWorkSpace && (0,mtstat/* statTrack */.SF)("landing_page_click", {
            region: "topnav"
        });
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            (0,login/* jumpToLogin */.lU)();
            return;
        }
        (0,login/* openVipModal */.C2)(params, closeCallback, payCallback);
    };
    const handleScroll = ()=>{
        const scrollY = window.scrollY;
        setHeaderStyle({
            // 根据滚动位置透明度自动计算
            backgroundColor: "rgba(255, 255, 255, ".concat(scrollY / 100 > 0.7 ? 0.7 : scrollY / 100, ")"),
            // 高斯模糊
            backdropFilter: "blur(".concat(scrollY / 100 > 25 ? 25 : scrollY / 100, "px)")
        });
    };
    (0,react.useEffect)(()=>{
        (0,login/* getUserInfo */.bG)();
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        utils_event/* default.on */.Z.on(constants_event/* UPDATE_USER_INFO */.r0, handleUpdateMeidouInfo);
        return ()=>{
            utils_event/* default.off */.Z.off(constants_event/* UPDATE_USER_INFO */.r0, handleUpdateMeidouInfo);
        };
    }, []);
    const handleUpdateMeidouInfo = ()=>{
        (0,login/* getUserInfo */.bG)();
    };
    const handleLogin = ()=>{
        (0,login/* jumpToLogin */.lU)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (index_module_default()).webHeader,
        style: headerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).left,
                children: [
                    isPersonal || !isPersonal && isWidgetsConfigDone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_logo/* default */.Z, {
                        logoUrl: logo/* default.src */.Z.src,
                        height: 30,
                        hideLogo: false,
                        hideSlogan: true,
                        hideCollectTip: true,
                        hideName: (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.type) === types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE,
                        showGuide: false,
                        target: "_self" // 打开首页方式，默认新开窗口，_self/_blank
                    }) : null,
                    isWidgetsConfigDone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_teamInfo, {}) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).right,
                children: [
                    isOpenPptCommercialization !== void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(navVipEntrance/* default */.Z, {
                        handleClick: ()=>handleOpenVip({
                                entrance: "topnav",
                                subscribe_type: "subscription"
                            }),
                        requestParams: isOpenPptCommercialization ? {
                            position: "LivePPT"
                        } : {},
                        track: mtstat/* statTrack */.SF,
                        uid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id
                    }) : null,
                    onCreate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (index_module_default()).createBtn,
                        onClick: onCreate,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                className: (index_module_default()).createIcon,
                                name: "PlusCircleBold",
                                fontSize: 16
                            }),
                            "从空白创建"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MeidouInfo, {
                        meidouInfo: meidouInfo,
                        project: constants/* SCENE */.vX,
                        onLogin: handleLogin,
                        onUpdateMeidouInfo: handleUpdateMeidouInfo,
                        autoSendDailyPresentedApi: true,
                        vipInfo: {
                            is_vip: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip) || false
                        },
                        onOpenVipModal: (params, closeCallback, payCallback)=>handleOpenVip(params, closeCallback, payCallback),
                        track: mtstat/* statTrack */.SF,
                        hideMeiDouRecordsEntrance: !!((ref = (0,lib/* getLocalIdentity */.u5)()) === null || ref === void 0 ? void 0 : ref.oid)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_userInfo, {
                        userInfo: userInfo,
                        meidouInfo: meidouInfo,
                        cutoutInfo: cutoutInfo
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const webHeader = (WebHeader);


/***/ }),

/***/ 90273:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ webWorkbench)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/index.module.css
var index_module = __webpack_require__(73352);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/layout/index.tsx + 4 modules
var layout = __webpack_require__(59043);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/webHeader/index.tsx + 2 modules
var webHeader = __webpack_require__(89203);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/hooks/usePPTGenerate.ts + 6 modules
var usePPTGenerate = __webpack_require__(25946);
// EXTERNAL MODULE: ./src/assets/images/banner-arrow.png
var banner_arrow = __webpack_require__(35266);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/index.js
var dist = __webpack_require__(98638);
// EXTERNAL MODULE: ./src/constants/workbench.ts
var workbench = __webpack_require__(40313);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/typeTabs/index.module.css
var typeTabs_index_module = __webpack_require__(77448);
var typeTabs_index_module_default = /*#__PURE__*/__webpack_require__.n(typeTabs_index_module);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(32711);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/typeTabs/index.tsx








const TabsContent = (props)=>{
    const { tabs , activeTab , setActiveTab  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (typeTabs_index_module_default()).tabs,
        children: tabs.map((v)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((typeTabs_index_module_default()).item, {
                    [(typeTabs_index_module_default()).active]: activeTab === v.key
                }),
                onClick: ()=>{
                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                        click_type: v.key === workbench/* TabKey.importFile */.Rc.importFile ? "upload_file_tab" : v.key === workbench/* TabKey.inAWord */.Rc.inAWord ? "one_sentence_tab" : "text_tab"
                    });
                    setActiveTab === null || setActiveTab === void 0 ? void 0 : setActiveTab(v.key);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        name: v.icon,
                        fontSize: activeTab === v.key ? 18 : 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (typeTabs_index_module_default()).name,
                        children: v.title
                    }),
                    v.tag && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (typeTabs_index_module_default()).tag,
                        src: v.tag,
                        alt: "tag"
                    })
                ]
            }, v.title);
        })
    });
};
/* harmony default export */ const typeTabs = (/*#__PURE__*/react.memo(TabsContent));

// EXTERNAL MODULE: ./src/components/deepSeekBtn/index.tsx + 2 modules
var deepSeekBtn = __webpack_require__(98773);
// EXTERNAL MODULE: ./src/components/pageSelect/index.tsx
var pageSelect = __webpack_require__(78175);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/inAWordContent/index.module.css
var inAWordContent_index_module = __webpack_require__(78994);
var inAWordContent_index_module_default = /*#__PURE__*/__webpack_require__.n(inAWordContent_index_module);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 23 modules
var input = __webpack_require__(6766);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(30060);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/css.js
var css = __webpack_require__(89566);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/css.js
var style_css = __webpack_require__(91225);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/inAWordContent/index.tsx








const { TextArea  } = input/* default */.Z;
const InAWordContent = (props)=>{
    const [inputFocus, setInputFocus] = (0,react.useState)(false);
    const inputEle = (0,react.useRef)(null);
    const [showTextArea, setShowTextArea] = (0,react.useState)(false);
    const { keyword , keywordChangeHandle , placeholder , enterHandle , onCreate  } = props;
    const isComposing = (0,react.useRef)(false);
    const handleComposition = (e)=>{
        if (e.type === "compositionstart") {
            isComposing.current = true;
        }
        if (e.type === "compositionend") {
            isComposing.current = false;
            keywordChangeHandle(e);
        }
    };
    const handleChange = (e)=>{
        if (!isComposing.current) {
            keywordChangeHandle(e);
        }
    };
    (0,react.useEffect)(()=>{
        if (keyword.length >= 30) {
            setShowTextArea(true);
        } else {
            setShowTextArea(false);
        }
    }, [
        keyword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (inAWordContent_index_module_default()).word,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((inAWordContent_index_module_default()).input, {
                focus: inputFocus
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (inAWordContent_index_module_default()).inputContent,
                    style: {
                        height: showTextArea ? "auto" : "72px"
                    },
                    children: [
                        showTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                            ref: inputEle,
                            maxLength: 300,
                            onChange: handleChange,
                            onCompositionStart: handleComposition,
                            onCompositionEnd: handleComposition,
                            onKeyDown: enterHandle,
                            defaultValue: keyword,
                            onFocus: (v)=>{
                                // 光标移动到最后
                                v.target.selectionStart = v.target.value.length;
                                setInputFocus(true);
                            },
                            rows: 5,
                            autoFocus: true,
                            onBlur: (v)=>{
                                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                    click_type: "inputbox"
                                });
                                setInputFocus(false);
                            },
                            placeholder: placeholder
                        }, keyword) : /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                            id: "inAWordContentInput",
                            ref: inputEle,
                            maxLength: 300,
                            onChange: handleChange,
                            onCompositionStart: handleComposition,
                            onCompositionEnd: handleComposition,
                            onKeyDown: enterHandle,
                            defaultValue: keyword,
                            onFocus: (v)=>{
                                // 光标移动到最后
                                v.target.selectionStart = v.target.value.length;
                                setInputFocus(true);
                            },
                            autoFocus: true,
                            onBlur: (v)=>{
                                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                    click_type: "inputbox"
                                });
                                setInputFocus(false);
                            },
                            placeholder: placeholder
                        }, keyword),
                        !showTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            "data-blue": true,
                            type: "primary",
                            onClick: onCreate,
                            children: "免费生成大纲"
                        }) : null
                    ]
                }),
                showTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                        "data-blue": true,
                        type: "primary",
                        onClick: onCreate,
                        style: {
                            margin: "10px auto 0"
                        },
                        children: "免费生成大纲"
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ const inAWordContent = (/*#__PURE__*/react.memo(InAWordContent));

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/try/index.module.css
var try_index_module = __webpack_require__(11083);
var try_index_module_default = /*#__PURE__*/__webpack_require__.n(try_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/try/index.tsx




const Try = (props)=>{
    const { recommendPromptList , activeRecommendIndex , recommendClick , keyword  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (try_index_module_default())["try"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (try_index_module_default()).title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "试试这些"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (try_index_module_default()).recommends,
                children: recommendPromptList.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((try_index_module_default()).recommend, {
                            [(try_index_module_default()).active]: index === activeRecommendIndex && keyword === item.prompt
                        }),
                        onDoubleClick: ()=>{
                            return recommendClick === null || recommendClick === void 0 ? void 0 : recommendClick(item, index);
                        },
                        onClick: ()=>{
                            return recommendClick === null || recommendClick === void 0 ? void 0 : recommendClick(item, index, false);
                        },
                        children: item.recommend
                    }, item.prompt);
                })
            })
        ]
    });
};
/* harmony default export */ const components_try = (/*#__PURE__*/react.memo(Try));

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/mdEditor/index.module.css
var mdEditor_index_module = __webpack_require__(91767);
var mdEditor_index_module_default = /*#__PURE__*/__webpack_require__.n(mdEditor_index_module);
// EXTERNAL MODULE: ./node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__(31298);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 6 modules
var tooltip = __webpack_require__(10780);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/css.js
var tooltip_style_css = __webpack_require__(51223);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
// EXTERNAL MODULE: ./src/utils/event.ts
var utils_event = __webpack_require__(26870);
// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/index.js
var core_dist = __webpack_require__(5865);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/index.js
var react_dist = __webpack_require__(71284);
// EXTERNAL MODULE: ./node_modules/prosemirror-state/dist/index.js
var prosemirror_state_dist = __webpack_require__(2376);
// EXTERNAL MODULE: ./node_modules/@tiptap/starter-kit/dist/index.js + 22 modules
var starter_kit_dist = __webpack_require__(54929);
// EXTERNAL MODULE: ./src/utils/markdownHelper.ts
var markdownHelper = __webpack_require__(98540);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-character-count/dist/index.js
var extension_character_count_dist = __webpack_require__(88776);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-placeholder/dist/index.js
var extension_placeholder_dist = __webpack_require__(93237);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-typography/dist/index.js
var extension_typography_dist = __webpack_require__(90214);
;// CONCATENATED MODULE: ./src/components/markdownEditor/index.tsx









const EventHandler = core_dist/* Extension.create */.hj.create({
    name: "eventHandler",
    addProseMirrorPlugins () {
        const { editor  } = this;
        return [
            new prosemirror_state_dist/* Plugin */.Sy({
                key: new prosemirror_state_dist/* PluginKey */.H$("eventHandler"),
                props: {
                    handlePaste (_, event) {
                        const { clipboardData  } = event;
                        if (!clipboardData) {
                            return false;
                        }
                        const text = clipboardData.getData("text/plain");
                        const html = clipboardData.getData("text/html");
                        if (html.length > 0) {
                            return false;
                        }
                        const content = text.split("\n").map((line)=>"<p>".concat(line, "</p>")).join("");
                        editor.commands.insertContent((0,core_dist/* generateJSON */.AW)(content, [
                            EventHandler,
                            starter_kit_dist/* default */.Z
                        ]), {
                            parseOptions: {
                                preserveWhitespace: "full"
                            }
                        });
                        return true;
                    }
                }
            })
        ];
    }
});
const MarkdownEditor = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { value , onChange , placeholder , onBlur , onFocus , autoFocus  } = props;
    const editor = (0,react_dist/* useEditor */.jE)({
        immediatelyRender: false,
        // autofocus: autoFocus,
        extensions: [
            starter_kit_dist/* default */.Z,
            extension_typography_dist/* default */.ZP,
            EventHandler,
            extension_placeholder_dist/* default.configure */.Z.configure({
                placeholder: placeholder || "粘贴您的笔记、大纲或任何文本内容可直接生成PPT"
            }),
            extension_character_count_dist/* default.configure */.Z.configure({
                limit: 0
            })
        ],
        onTransaction (props) {
            const { editor  } = props;
            const html = editor.getHTML();
            const markdown = markdownHelper/* turndownService.turndown */.uD.turndown(html);
            onChange && onChange(markdown, html, (editor === null || editor === void 0 ? void 0 : editor.storage.characterCount.characters()) || 0);
        },
        onBlur: ()=>{
            onBlur && onBlur();
        },
        onFocus: ()=>{
            onFocus && onFocus();
        },
        content: value
    });
    (0,react.useImperativeHandle)(ref, ()=>({
            editor: ()=>editor
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist/* EditorContent */.kg, {
        editor: editor
    });
});
MarkdownEditor.displayName = "MarkdownEditor";
/* harmony default export */ const markdownEditor = (/*#__PURE__*/react.memo(MarkdownEditor));

;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/mdEditor/index.tsx












const MdEditor = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    var ref1, ref2, ref3, ref4;
    const { onChange , value , visibleTooltip =false , onBlur , disabled , onClick  } = props;
    const [visible, setVisible] = (0,react.useState)(visibleTooltip);
    const editorRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        utils_event/* default.on */.Z.on("AI_PPT_SCROLL", ()=>{
            setVisible(false);
        });
        return ()=>{
            utils_event/* default.off */.Z.off("AI_PPT_SCROLL", ()=>{});
        };
    }, []);
    (0,react.useEffect)(()=>{
        setVisible(visibleTooltip);
    }, [
        visibleTooltip
    ]);
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            getEditor: ()=>{
                var ref;
                return (ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.editor();
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (mdEditor_index_module_default()).mdEditor,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Scrollbars */.$B, {
                    className: classnames_default()((mdEditor_index_module_default()).mdEditorWrapper, {
                        [(mdEditor_index_module_default()).mdEditorWrapperSafari]: (0,utils/* isSafari */.G6)()
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdownEditor, {
                        ref: editorRef,
                        value: value,
                        onChange: onChange,
                        onBlur: onBlur
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    open: visible,
                    title: "请删除超出字数限制部分",
                    placement: "bottom",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "len-info",
                        className: classnames_default()((mdEditor_index_module_default()).lenInfo, {
                            [(mdEditor_index_module_default()).lenInfoError]: ((ref2 = (ref1 = editorRef.current) === null || ref1 === void 0 ? void 0 : ref1.editor()) === null || ref2 === void 0 ? void 0 : ref2.storage.characterCount.characters()) > workbench/* RICH_TEXT_MAX_LEN */.aR
                        }),
                        children: [
                            (ref4 = (ref3 = editorRef.current) === null || ref3 === void 0 ? void 0 : ref3.editor()) === null || ref4 === void 0 ? void 0 : ref4.storage.characterCount.characters(),
                            " /",
                            " ",
                            workbench/* RICH_TEXT_MAX_LEN */.aR
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    "data-blue": true,
                    disabled: disabled,
                    type: "primary",
                    onClick: onClick,
                    children: "免费生成大纲"
                })
            ]
        })
    });
});
MdEditor.displayName = "MdEditor";
/* harmony default export */ const mdEditor = (/*#__PURE__*/react.memo(MdEditor));

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/importFile/index.module.css
var importFile_index_module = __webpack_require__(2558);
var importFile_index_module_default = /*#__PURE__*/__webpack_require__.n(importFile_index_module);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/progress/index.module.css
var progress_index_module = __webpack_require__(31532);
var progress_index_module_default = /*#__PURE__*/__webpack_require__.n(progress_index_module);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 10 modules
var progress = __webpack_require__(41798);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/style/css.js
var progress_style_css = __webpack_require__(4748);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/progress/index.tsx






const CustomProgress = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { loading , files =[] , onClose  } = param;
    const [percent, setPercent] = (0,react.useState)(0);
    const interval = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (loading) {
            // 当 loading 为 true 时，开始增加进度
            interval.current = setInterval(()=>{
                setPercent((prevPercent)=>{
                    if (prevPercent < 90) {
                        return prevPercent + 10; // 每次增加 10%
                    } else {
                        clearInterval(interval.current);
                        return prevPercent;
                    }
                });
            }, 1000);
        } else {
            // 当 loading 为 false 时，重置进度条
            setPercent(0);
        }
        // 清理副作用
        return ()=>{
            if (interval.current) {
                clearInterval(interval.current);
            }
        };
    }, [
        loading
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            progressFinish: ()=>{
                clearInterval(interval.current);
                setPercent(100);
            }
        }));
    const close = (file)=>{
        onClose && onClose(file);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (progress_index_module_default()).webProgress,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (progress_index_module_default()).webProgressText,
                children: [
                    "文件上传中...(",
                    percent,
                    ")%"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                percent: percent,
                type: "line",
                showInfo: false,
                strokeColor: "#66A8FF",
                status: "active",
                strokeWidth: 6
            }),
            files.map((v)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (progress_index_module_default()).webProgressFile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: v.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            className: (progress_index_module_default()).fileClose,
                            fontSize: 10,
                            name: "CrossBold",
                            onClick: ()=>close(v)
                        })
                    ]
                }, v.lastModified);
            })
        ]
    });
});
CustomProgress.displayName = "CustomProgress";
/* harmony default export */ const components_progress = (/*#__PURE__*/react.memo(CustomProgress));

// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 5 modules
var message = __webpack_require__(27721);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/css.js
var message_style_css = __webpack_require__(79636);
;// CONCATENATED MODULE: ./src/hooks/useFileUpload.ts

function useFileUpload(onFileUpload) {
    const [files, setFiles] = (0,react.useState)([]);
    // 处理文件选择
    const handleFileChange = (event)=>{
        const selectedFiles = Array.from(event.target.files || []);
        setFiles(selectedFiles);
        if (onFileUpload) {
            onFileUpload(selectedFiles);
        }
    };
    // 处理拖拽文件
    const handleDrop = (event)=>{
        window._stat_track("tools_click_ppt_home", {
            click_type: "upload_file_touch"
        });
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        const lastFiles = droppedFiles[droppedFiles.length - 1];
        setFiles([
            lastFiles
        ]);
        if (onFileUpload) {
            onFileUpload([
                lastFiles
            ]);
        }
    };
    // 阻止默认拖拽行为
    const handleDragOver = (event)=>{
        event.preventDefault();
    };
    // 清空文件列表
    const clearFiles = (0,react.useCallback)(()=>{
        setFiles([]);
    }, []);
    return {
        files,
        handleFileChange,
        handleDrop,
        handleDragOver,
        clearFiles
    };
}
/* harmony default export */ const hooks_useFileUpload = (useFileUpload);

// EXTERNAL MODULE: ./src/utils/uploadManager/index.ts + 2 modules
var uploadManager = __webpack_require__(21343);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/importFile/index.tsx














const ImportFile = (props)=>{
    const { loading , onClose , uploadFile , setLoading , toPasteText , chancelUpload  } = props;
    const fileInputRef = (0,react.useRef)(null);
    const progressRef = (0,react.useRef)();
    const [uploadError, setUploadError] = (0,react.useState)(false);
    const { handleFileChange , handleDrop , handleDragOver , files  } = hooks_useFileUpload(async (uploadedFiles)=>{
        ;
        if (uploadedFiles[0]) {
            try {
                const fileNames = uploadedFiles[0].name.split(".");
                ;
                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                    click_type: "upload_file_begin",
                    upload_file_format: fileNames[fileNames.length - 1]
                });
                setLoading(true);
                const file = uploadedFiles[0];
                const nameSplits = file.name.split(".");
                const fileType = nameSplits[nameSplits.length - 1];
                if (file.name.endsWith(".pdf") || file.name.endsWith(".ppt") || file.name.endsWith(".pptx")) {
                    // pdf 走服务端上传
                    const res = await (0,uploadManager/* uploadFileToObs */.yk)(file, undefined, "ai_ppt", // '.pdf'
                    fileType);
                    if (chancelUpload.current) {
                        return;
                    }
                    ;
                    const fileUrl = res.url;
                    uploadFile === null || uploadFile === void 0 ? void 0 : uploadFile(fileUrl, fileType);
                    setUploadError(false);
                    return;
                } else {
                    const html = await (0,markdownHelper/* file2html */.pb)(file);
                    let markdown = markdownHelper/* turndownService.turndown */.uD.turndown(html);
                    ;
                    if (markdown.trim().length === 0) {
                        // 内容为空
                        message/* default.error */.ZP.error("未检测到文字，请确认文件是否全为图片");
                        setLoading(false);
                        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                            click_type: "upload_file_fail"
                        });
                        return;
                    }
                    if (chancelUpload.current) {
                        return;
                    }
                    if (markdown.length > workbench/* FILE_TEXT_MAX_LEN */.HZ) {
                        markdown = markdown.substring(0, workbench/* FILE_TEXT_MAX_LEN */.HZ);
                        message/* default.info */.ZP.info("已解析该文件前3w字内容");
                    }
                    uploadFile === null || uploadFile === void 0 ? void 0 : uploadFile(markdown, "other");
                    setUploadError(false);
                    clearFileStatus();
                }
            } catch (error) {
                ;
                clearFileStatus();
                setUploadError(true);
                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                    click_type: "upload_file_fail"
                });
            }
        }
    });
    // 重置上传的一些状态
    const clearFileStatus = async ()=>{
        var ref;
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        (ref = progressRef.current) === null || ref === void 0 ? void 0 : ref.progressFinish();
        await (0,utils/* sleep */._v)(1000);
        setLoading(false);
    };
    const fileButtonClick = ()=>{
        var ref;
        chancelUpload.current = false;
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "upload_file_touch"
        });
        (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    const fileClose = ()=>{
        chancelUpload.current = true;
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "upload_file_fail"
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setLoading(false);
        clearFileStatus();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (importFile_index_module_default())["import"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "file",
                ref: fileInputRef,
                style: {
                    display: "none"
                },
                accept: ".docx,.pptx,.pdf,.xmind,.txt",
                onChange: handleFileChange
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (importFile_index_module_default()).importContent,
                onDrop: (e)=>{
                    chancelUpload.current = false;
                    handleDrop(e);
                },
                onDragOver: handleDragOver,
                children: [
                    !uploadError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                className: (importFile_index_module_default()).importButton,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    name: "UploadFlowBold",
                                    fontSize: 18
                                }),
                                type: "primary",
                                onClick: fileButtonClick,
                                children: "点击或拖拽文件上传"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (importFile_index_module_default()).importMessage,
                                children: "*支持上传3万字以内的word、pdf、ppt、xmind、txt等文件格式，不保留图片、图表等内容"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (importFile_index_module_default()).importMessage,
                                children: "*上传的PPT文件会重新润色文本和结构后生成新PPT"
                            })
                        ]
                    }),
                    uploadError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (importFile_index_module_default()).importMessage,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        name: "ExclamationMarkCircleBold",
                                        fontSize: 16
                                    }),
                                    "该文件格式暂不支持，可以试试",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: ()=>{
                                            toPasteText === null || toPasteText === void 0 ? void 0 : toPasteText();
                                            setTimeout(()=>{
                                                setUploadError(false);
                                            }, 300);
                                        },
                                        children: "已有文本生成"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                className: (importFile_index_module_default()).afreshButton,
                                type: "primary",
                                onClick: fileButtonClick,
                                children: "重新上传"
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (importFile_index_module_default()).importContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_progress, {
                    files: files,
                    loading: loading,
                    onClose: fileClose,
                    ref: progressRef
                })
            })
        ]
    });
};
/* harmony default export */ const importFile = (/*#__PURE__*/react.memo(ImportFile));

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useUserHelper.ts
var useUserHelper = __webpack_require__(62893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/query.ts
var utils_query = __webpack_require__(3269);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/record/index.module.css
var record_index_module = __webpack_require__(38770);
var record_index_module_default = /*#__PURE__*/__webpack_require__.n(record_index_module);
;// CONCATENATED MODULE: ./src/assets/images/ppt-ai.png
/* harmony default export */ const ppt_ai = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/ppt-ai.9fa2c9b5.png","height":32,"width":71,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/Ab/822cEAwWSAgACBvwA/f/5+AUA+voLAfz5C/QC+gVeAcT/4PTr6OcL3dLb/ys8RgG8p7cAERYi/igdLwIUBw/hAcL/4/To4u4L2tLr/xwjKAHBnqUAHx4l/j4wSQIJAQjgAbP06WcA/hCTAvsGBf7q/f8J9QAAA/L8AQYBB/X+/v9dSd8+l1Fz9dMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./src/services/workbench/index.ts
var services_workbench = __webpack_require__(82425);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/record/index.tsx









const HEIGHT = 140;
const Record = (props)=>{
    const { onRecordClick , col , totalWidth , gap , width  } = props;
    const cursor = (0,react.useRef)("");
    const [list, setList] = (0,react.useState)([]);
    const [hasMore, setHasMore] = (0,react.useState)(true);
    const loadRef = (0,react.useRef)(null);
    const hasMoreRef = (0,react.useRef)(true);
    const isIntRef = (0,react.useRef)(true);
    const [show, setShow] = (0,react.useState)(true);
    const count = (0,react.useRef)("20");
    const [loading, setLoading] = (0,react.useState)(false);
    const [hasCursor, setHasCursor] = (0,react.useState)(false);
    const getList = async ()=>{
        try {
            var ref, ref1, ref2;
            setLoading(true);
            const res = await (0,services_workbench/* fetchRecordList */.Ng)({
                type: 2,
                cursor: cursor.current,
                count: count.current
            });
            ;
            setHasMore(!!((ref = res.data.data) === null || ref === void 0 ? void 0 : ref.cursor));
            cursor.current = ((ref1 = res.data.data) === null || ref1 === void 0 ? void 0 : ref1.cursor) || "";
            setHasCursor(!!cursor.current);
            hasMoreRef.current = !!((ref2 = res.data.data) === null || ref2 === void 0 ? void 0 : ref2.cursor);
            setList((oldList)=>{
                var ref;
                return [
                    ...oldList,
                    ...(ref = res.data.data) === null || ref === void 0 ? void 0 : ref.materials
                ];
            });
        } finally{
            setLoading(false);
        }
    // if (isIntRef.current) {
    //     isIntRef.current = false;
    //     loadMore();
    // }
    };
    (0,react.useEffect)(()=>{
        if (list.length) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [
        list
    ]);
    (0,react.useEffect)(()=>{
        getList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (record_index_module_default()).pptRecord,
        style: {
            width: totalWidth
        },
        children: [
            list.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (record_index_module_default()).pptRecordList,
                children: list.map((item, i)=>{
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: ()=>{
                            return onRecordClick === null || onRecordClick === void 0 ? void 0 : onRecordClick(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (record_index_module_default()).pptRecordListItem,
                                style: {
                                    width: width,
                                    height: HEIGHT,
                                    marginRight: (i + 1) % col === 0 ? 0 : gap,
                                    // 第一行的 marginTop 为0，其他为24
                                    marginTop: i < col ? 0 : 24
                                },
                                children: [
                                    item.poster_type === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 35,
                                        height: 16,
                                        src: ppt_ai,
                                        className: (record_index_module_default()).pptRecordListItemIcon,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (record_index_module_default()).pptRecordListItemTag,
                                        children: "PPT ".concat(item.canvas_pages, "页")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (record_index_module_default()).pptRecordListItemPreview,
                                        width: ((ref = item.material) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.preview) === null || ref2 === void 0 ? void 0 : ref2.width) || 0,
                                        height: ((ref3 = item.material) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.preview) === null || ref5 === void 0 ? void 0 : ref5.height) || 0,
                                        src: (0,utils/* thumbnail */.Q1)(((ref6 = item.material) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.meta) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.preview) === null || ref8 === void 0 ? void 0 : ref8.url) || ""),
                                        alt: ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (record_index_module_default()).pptRecordListItemName,
                                style: {
                                    width: width
                                },
                                title: "".concat(item.name || "未命名的设计.PPT"),
                                children: item.name || "未命名的设计.PPT"
                            })
                        ]
                    }, item.id);
                })
            }) : null,
            !hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: loadRef,
                className: (record_index_module_default()).pptRecordLoad,
                children: "没有更多了~"
            }),
            hasMore && list.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (record_index_module_default()).pptRecordLoadMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    onClick: getList,
                    children: "加载更多"
                })
            })
        ]
    });
};
/* harmony default export */ const record = (/*#__PURE__*/react.memo(Record));

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/templates/index.module.css
var templates_index_module = __webpack_require__(22984);
var templates_index_module_default = /*#__PURE__*/__webpack_require__.n(templates_index_module);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/tagSelect/index.module.css
var tagSelect_index_module = __webpack_require__(71085);
var tagSelect_index_module_default = /*#__PURE__*/__webpack_require__.n(tagSelect_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/tagSelect/index.tsx






const TagSelect = (props)=>{
    const { list , active , title , onTagSelect , config ={
        label: "label",
        value: "value",
        desc: "desc",
        icon: "icon"
    }  } = props;
    const { label , value , desc , icon  } = config;
    const wrapRef = (0,react.useRef)(null);
    const scrollRef = (0,react.useRef)(null); // 新增对滚动容器的引用
    const [showAction, setShowAction] = (0,react.useState)(false);
    const [showLeft, setShowLeft] = (0,react.useState)(false);
    const [showRight, setShowRight] = (0,react.useState)(false);
    const scrollStep = 200; // 定义滚动的步长
    (0,react.useEffect)(()=>{
        const scrollRefCurrent = scrollRef.current;
        if (scrollRefCurrent) {
            setShowAction(scrollRefCurrent.scrollWidth > scrollRefCurrent.clientWidth);
            setShowRight(scrollRefCurrent.scrollWidth > scrollRefCurrent.clientWidth);
        }
    }, [
        list
    ]);
    // 向左滚动
    const handleScrollLeft = ()=>{
        if (scrollRef.current) {
            scrollRef.current.scrollLeft -= scrollStep;
            setTimeout(()=>{
                const currentScrollLeft = scrollRef.current.scrollLeft;
                // 判断是否已滚动到最左侧
                if (currentScrollLeft <= 63) {
                    setShowLeft(false);
                    setShowRight(true);
                } else {
                    setShowLeft(true);
                    setShowRight(true);
                }
            }, 500);
        }
    };
    // 向右滚动
    const handleScrollRight = ()=>{
        if (scrollRef.current) {
            scrollRef.current.scrollLeft += scrollStep;
            setTimeout(()=>{
                const currentScrollLeft = scrollRef.current.scrollLeft;
                const scrollWidth = scrollRef.current.scrollWidth; // 总滚动宽度
                const clientWidth = scrollRef.current.clientWidth; // 可视区域宽度
                ;
                // 判断是否已滚动到最右侧
                if (currentScrollLeft >= scrollWidth - clientWidth) {
                    setShowRight(false);
                    setShowLeft(true);
                } else {
                    setShowRight(true);
                    setShowLeft(true);
                }
            }, 500);
        }
    };
    const tagSelect = (item)=>{
        onTagSelect === null || onTagSelect === void 0 ? void 0 : onTagSelect(item[value]);
    };
    const renderList = ()=>{
        return list.map((item)=>{
            return item[desc] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                title: item[desc],
                placement: "top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((tagSelect_index_module_default()).tagSelectItem, " ").concat(active === item[value] ? (tagSelect_index_module_default()).active : ""),
                    onClick: ()=>tagSelect(item),
                    children: [
                        item[icon] && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            name: item[icon],
                            fontSize: 14,
                            style: {
                                marginRight: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: item[label]
                        })
                    ]
                })
            }, item[value]) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((tagSelect_index_module_default()).tagSelectItem, " ").concat(active === item[value] ? (tagSelect_index_module_default()).active : ""),
                onClick: ()=>tagSelect(item),
                children: [
                    item[icon] && !item[icon].includes("http") && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        name: item[icon],
                        fontSize: 14,
                        style: {
                            marginRight: 4
                        }
                    }),
                    item[icon] && item[icon].includes("http") && // eslint-disable-next-line @next/next/no-img-element
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (tagSelect_index_module_default()).newIcon,
                        src: item[icon],
                        alt: "图片"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: item[label]
                    })
                ]
            }, item[value]);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapRef,
        className: (tagSelect_index_module_default()).tagSelect,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tagSelect_index_module_default()).tagSelectTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (tagSelect_index_module_default()).tagListAction,
                children: [
                    showAction && showLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((tagSelect_index_module_default()).actionIcon, " ").concat((tagSelect_index_module_default()).actionLeft),
                        onClick: handleScrollLeft,
                        style: {
                            left: title ? 68 : 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            name: "ChevronLeftBlack"
                        })
                    }),
                    showAction && showRight && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((tagSelect_index_module_default()).actionIcon, " ").concat((tagSelect_index_module_default()).actionRight),
                        onClick: handleScrollRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            name: "ChevronRightBlack"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tagSelect_index_module_default()).tagSelectList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (tagSelect_index_module_default()).tagSelectScroll,
                    ref: scrollRef,
                    children: renderList()
                })
            })
        ]
    });
};
/* harmony default export */ const components_tagSelect = (/*#__PURE__*/react.memo(TagSelect));

// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(48648);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/css.js
var spin_style_css = __webpack_require__(98687);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 16 modules
var LoadingOutlined = __webpack_require__(7373);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/templates/index.tsx












const Templates = (props)=>{
    const [styleList, setStyleList] = (0,react.useState)([]);
    const [active, setActive] = (0,react.useState)("");
    const { col , totalWidth , gap , width  } = props;
    const cursor = (0,react.useRef)("");
    const [list, setList] = (0,react.useState)([]);
    const [hasMore, setHasMore] = (0,react.useState)(true);
    const loadRef = (0,react.useRef)(null);
    const hasMoreRef = (0,react.useRef)(true);
    const isIntRef = (0,react.useRef)(true);
    const [show, setShow] = (0,react.useState)(true);
    const count = (0,react.useRef)("20");
    const [loading, setLoading] = (0,react.useState)(false);
    const [hasCursor, setHasCursor] = (0,react.useState)(false);
    const getList = async function(id) {
        let init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        try {
            var ref, ref1, ref2;
            setLoading(true);
            const res = await getTemplates(id);
            ;
            setHasMore(!!((ref = res.data.data) === null || ref === void 0 ? void 0 : ref.cursor));
            cursor.current = ((ref1 = res.data.data) === null || ref1 === void 0 ? void 0 : ref1.cursor) || "";
            setHasCursor(!!cursor.current);
            hasMoreRef.current = !!((ref2 = res.data.data) === null || ref2 === void 0 ? void 0 : ref2.cursor);
            if (init) {
                var ref3;
                setList((ref3 = res.data.data) === null || ref3 === void 0 ? void 0 : ref3.materials);
                return;
            }
            setList((oldList)=>{
                var ref;
                return [
                    ...oldList,
                    ...(ref = res.data.data) === null || ref === void 0 ? void 0 : ref.materials
                ];
            });
        } finally{
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (list.length) {
            setShow(true);
        } else {
            setShow(false);
        }
        trackFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        list
    ]);
    (0,react.useEffect)(()=>{
        getList("", true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const trackFn = ()=>{
        const items = document.querySelectorAll(".".concat((templates_index_module_default()).templatesListItem));
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry, i)=>{
                if (entry.isIntersecting) {
                    // 在这里，通常也可以用于埋点曝光统计
                    const item = entry.target;
                    if (item.getAttribute("data-track")) return;
                    item.setAttribute("data-track", "1");
                    (0,mtstat/* statTrack */.SF)("template_show", {
                        industry_id: "",
                        scene_id: "",
                        topic: active,
                        template_id: item.getAttribute("data-id"),
                        entry: "aippt_home",
                        type: 7
                    });
                    observer.unobserve(item);
                }
            });
        });
        items.forEach((img)=>observer.observe(img));
    };
    const getInitData = async ()=>{
        const res = await (0,services_workbench/* fetchTemplateCenterInit */.eR)();
        setStyleList([
            {
                id: "",
                name: "全部"
            },
            ...res.data.data.styles
        ]);
    };
    const getTemplates = async (id)=>{
        return await (0,services_workbench/* fetchPPTTemplate */.zf)({
            center_filter: JSON.stringify({
                sort: "normal",
                filter_ids: "2130".concat(id ? "," + id : id)
            }),
            cursor: cursor.current,
            count: count.current
        });
    };
    (0,react.useEffect)(()=>{
        getInitData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (templates_index_module_default()).templatesWrap,
        style: {
            width: totalWidth
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tagSelect, {
                list: styleList,
                active: active,
                config: {
                    label: "name",
                    value: "id"
                },
                onTagSelect: (v)=>{
                    setHasMore(true);
                    cursor.current = "";
                    // setList([]);
                    setActive(v);
                    getList(v, true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (templates_index_module_default()).templatesList,
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (templates_index_module_default()).templatesListLoading,
                        style: {
                            paddingTop: list.length ? "100px" : "0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                            indicator: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                style: {
                                    fontSize: 48,
                                    color: "#fff"
                                },
                                spin: true
                            })
                        })
                    }),
                    list.map((item, i)=>{
                        var ref, ref1, ref2;
                        // 计算出需要缩放的倍数
                        const scale = width / ((ref = item.thumbnail) === null || ref === void 0 ? void 0 : ref.width);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>{
                                (0,mtstat/* statTrack */.SF)("template_click", {
                                    industry_id: "",
                                    scene_id: "",
                                    topic: active,
                                    template_id: item.id,
                                    entry: "aippt_home",
                                    type: 7
                                });
                                const url = "".concat((0,constants/* getDesignHome */.y$)(), "/design");
                                window.open("".concat(url, "?id=").concat(item.id, "&origin=ai-ppt"));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (templates_index_module_default()).templatesListItem,
                                "data-id": item.id,
                                style: {
                                    width: width,
                                    // height: HEIGHT,
                                    marginRight: (i + 1) % col === 0 ? 0 : gap,
                                    // 第一行的 marginTop 为0，其他为24
                                    marginTop: i < col ? 0 : 24
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,utils/* thumbnail */.Q1)(((ref1 = item.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) || ""),
                                    alt: "",
                                    width: width,
                                    height: ((ref2 = item.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.height) * scale
                                })
                            })
                        }, item.id);
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: loadRef,
                className: (templates_index_module_default()).templatesLoad,
                children: "加载中..."
            }),
            !hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: loadRef,
                className: (templates_index_module_default()).templatesLoad,
                children: "没有更多了~"
            }),
            hasMore && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (templates_index_module_default()).templatesLoadMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    onClick: ()=>getList(active),
                    children: "加载更多"
                })
            })
        ]
    });
};
/* harmony default export */ const templates = (/*#__PURE__*/react.memo(Templates));

// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/css.js
var input_number_style_css = __webpack_require__(75937);
// EXTERNAL MODULE: ./src/components/fetchLoading/views/pptOutlineLoading.tsx + 1 modules
var pptOutlineLoading = __webpack_require__(71635);
;// CONCATENATED MODULE: ./src/assets/images/next-arrow.png
/* harmony default export */ const next_arrow = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/next-arrow.fe3176f8.png","height":31,"width":36,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAQAAACfUMTVAAAAX0lEQVR42j3IIQ6CAAAF0C9OjqDdoDPrCZyBc1i8hdl7eASrF3Cz2OxU2IikNwiMvfYiYikeKlFGRCEqjZPEXC5qx3j7+ox+Xlp9bO3tHGycdW4xsfZ3lVgorMTTXZQDPodGejzgITUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/components/typed/index.tsx
var typed = __webpack_require__(32454);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/outlineTree/index.tsx
var outlineTree = __webpack_require__(79790);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 1 modules
var popover = __webpack_require__(26368);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/style/css.js
var popover_style_css = __webpack_require__(31708);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/templateSelect/index.module.css
var templateSelect_index_module = __webpack_require__(46867);
var templateSelect_index_module_default = /*#__PURE__*/__webpack_require__.n(templateSelect_index_module);
;// CONCATENATED MODULE: ./src/components/lazyImage/index.tsx


const LazyImage = (param)=>{
    let { src , alt , placeholder , ...rest } = param;
    const imgRef = (0,react.useRef)(null);
    const [isLoaded, setIsLoaded] = (0,react.useState)(false);
    const [inView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (imgRef.current) {
            observer.observe(imgRef.current);
        }
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return(// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ref: imgRef,
        src: inView ? src : placeholder,
        alt: alt,
        onLoad: ()=>setIsLoaded(true),
        style: {
            ...rest.style
        },
        ...rest
    }));
};
/* harmony default export */ const lazyImage = (/*#__PURE__*/react.memo(LazyImage));

;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/templateSelect/index.tsx















const GenBtn = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2146).then(__webpack_require__.bind(__webpack_require__, 72146)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72146)
            ]
    },
    ssr: false
});
const ItemPopover = (props)=>{
    const { v , activeTemplate , setActiveTemplate , supportWebp  } = props;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
        overlayClassName: (templateSelect_index_module_default()).templateItemPopoverOverlay,
        destroyTooltipOnHide: true,
        placement: "rightTop",
        showArrow: false,
        align: {
            offset: [
                4,
                -16
            ]
        },
        open: open,
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (templateSelect_index_module_default()).templateItemPopover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazyImage, {
                src: v.full_preview || v.url,
                loading: "lazy",
                alt: "",
                width: 168,
                height: v.full_preview ? 190 : v.width < v.height ? 190 : 95
            })
        }),
        trigger: "hover",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()({
                [(templateSelect_index_module_default()).templateItem]: true,
                [(templateSelect_index_module_default()).templateItemActive]: activeTemplate === v.template_id
            }),
            onMouseEnter: ()=>setOpen(true),
            onMouseLeave: ()=>setOpen(false),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lazyImage, {
                    className: (templateSelect_index_module_default()).img,
                    loading: "lazy",
                    // width={212}
                    // height={120}
                    src: v.display_pic || v.url,
                    alt: "",
                    onClick: ()=>{
                        if (v.template_id === activeTemplate) return;
                        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                            click_type: "pick_template"
                        });
                        setActiveTemplate(v.template_id);
                    }
                }, v.template_id),
                v.corner_mark_url && // eslint-disable-next-line @next/next/no-img-element
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (templateSelect_index_module_default()).newTagIcon,
                    src: v.corner_mark_url,
                    alt: ""
                })
            ]
        })
    });
};
const TemplateSelect = (props)=>{
    const { tagSelect , activeTag , setActiveTag , activeTemplate , templateList , setActiveTemplate , onGen , handleErrorMessage  } = props;
    const userInfo = (0,useUserHelper/* useGetUserInfo */.Jh)();
    const supportWebp = (0,utils/* isSupportWebp */.R$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (templateSelect_index_module_default()).templateSelect,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tagSelect, {
                    list: tagSelect,
                    active: activeTag,
                    config: {
                        label: "category_name",
                        value: "category_name",
                        icon: "category_tag"
                    },
                    title: "模板风格：",
                    onTagSelect: (v)=>{
                        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                            click_type: "template_style"
                        });
                        setActiveTag(v);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (templateSelect_index_module_default()).templateList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                    autoHide: true,
                    className: (templateSelect_index_module_default()).templateListScroll,
                    children: templateList.map((v, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPopover, {
                            supportWebp: supportWebp,
                            v: v,
                            activeTemplate: activeTemplate,
                            setActiveTemplate: setActiveTemplate
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (templateSelect_index_module_default()).buttons,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenBtn, {
                    uuid: workbench/* BTN_UUID */.pR,
                    isFree: (0,utils/* isFromHuaweiCustom */.MH)() || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip),
                    className: (templateSelect_index_module_default()).createButton,
                    text: "开始生成PPT",
                    hideDesc: true,
                    onGen: onGen,
                    onErrorMessage: handleErrorMessage,
                    source: constants/* SCENE */.vX
                })
            })
        ]
    });
};
/* harmony default export */ const templateSelect = (/*#__PURE__*/react.memo(TemplateSelect));

;// CONCATENATED MODULE: ./src/components/fetchLoading/lottie/pptCreateLoading.json
const pptCreateLoading_namespaceObject = JSON.parse('{"v":"5.6.1","fr":60,"ip":0,"op":300,"w":312,"h":160,"nm":"little","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Sector 2","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[-3.253,1.621,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[21.187,-5.662,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[21.188,-5.662,0],"to":[0,0,0],"ti":[0,0,0]},{"t":296,"s":[-3.253,1.621,0]}],"ix":2},"a":{"a":0,"k":[-3.812,2.125,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"高斯模糊","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"模糊度","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":7,"nm":"模糊方向","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"重复边缘像素","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[{"i":[[0,-0.967],[0,0],[23.812,0],[0,0],[0,8.341],[0,0],[0,0.986],[-0.001,0.106],[-18.386,0],[0,-21.547]],"o":[[0,0],[0,10.34],[0,0],[-26.28,0],[0,0],[0,-1.004],[0,-0.106],[0.153,-20.158],[17.618,0],[0,0.95]],"v":[[32.827,4.424],[32.821,4.437],[-0.344,35.477],[-0.352,35.412],[-33.947,4.383],[-33.933,4.373],[-33.858,3.674],[-33.857,3.357],[-0.592,-30.277],[32.695,3.733]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[0,-0.499],[0,0],[3.093,0],[0,0],[0,3.081],[0,0],[-0.039,0.487],[-0.005,0.055],[-9.496,0],[-0.758,-9.318]],"o":[[0,0],[0,3.081],[0,0],[-3.093,0],[0,0],[0,-0.497],[0.005,-0.056],[0.834,-9.242],[9.551,0],[0.04,0.489]],"v":[[14.389,3.519],[14.389,13.281],[8.788,18.858],[-16.413,18.858],[-22.014,13.281],[-22.014,3.519],[-21.954,2.043],[-21.94,1.876],[-3.812,-14.608],[14.329,2.036]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[{"i":[[0,-0.499],[0,0],[3.093,0],[0,0],[0,3.081],[0,0],[-0.039,0.487],[-0.005,0.055],[-9.496,0],[-0.758,-9.318]],"o":[[0,0],[0,3.081],[0,0],[-3.093,0],[0,0],[0,-0.497],[0.005,-0.056],[0.834,-9.242],[9.551,0],[0.04,0.489]],"v":[[14.389,3.519],[14.389,13.281],[8.788,18.858],[-16.413,18.858],[-22.014,13.281],[-22.014,3.519],[-21.954,2.043],[-21.94,1.876],[-3.812,-14.608],[14.329,2.036]],"c":true}]},{"t":296,"s":[{"i":[[0,-0.967],[0,0],[23.812,0],[0,0],[0,8.341],[0,0],[0,0.986],[-0.001,0.106],[-18.386,0],[0,-21.547]],"o":[[0,0],[0,10.34],[0,0],[-26.28,0],[0,0],[0,-1.004],[0,-0.106],[0.153,-20.158],[17.618,0],[0,0.95]],"v":[[32.827,4.424],[32.821,4.437],[-0.344,35.477],[-0.352,35.412],[-33.947,4.383],[-33.933,4.373],[-33.858,3.674],[-33.857,3.357],[-0.592,-30.277],[32.695,3.733]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0.066666662693,0.944000065327,1,1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[0.066666662693,0.944000065327,1,1]},{"t":280,"s":[0.066666662693,0.944000065327,1,1]}],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Sector","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":239,"op":301,"st":239,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Vector 1316","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[90]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":280,"s":[90]},{"t":296,"s":[0]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[-7.302,6.654,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"t":260,"s":[20.698,38.617,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[20.698,38.617,0],"to":[0,0,0],"ti":[0,0,0]},{"t":296,"s":[-7.302,6.654,0]}],"ix":2},"a":{"a":0,"k":[-7.337,6.619,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"高斯模糊","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"模糊度","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":7,"nm":"模糊方向","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"重复边缘像素","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[{"i":[[0,0],[-12.639,-12.639],[12.639,-12.639],[0,0],[12.639,12.639],[-12.639,12.639]],"o":[[12.639,-12.639],[12.639,12.639],[0,0],[-12.639,12.639],[-12.639,-12.639],[0,0]],"v":[[-22.946,-20.876],[22.825,-20.876],[22.825,24.896],[22.952,24.943],[-22.82,24.943],[-22.82,-20.828]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[0,0],[-3.051,-3.051],[3.051,-3.051],[0,0],[3.051,3.051],[-3.051,3.051]],"o":[[3.051,-3.051],[3.051,3.051],[0,0],[-3.051,3.051],[-3.051,-3.051],[0,0]],"v":[[-2.062,-9.706],[8.987,-9.706],[8.987,1.343],[-12.613,22.942],[-23.661,22.942],[-23.661,11.894]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[{"i":[[0,0],[-3.051,-3.051],[3.051,-3.051],[0,0],[3.051,3.051],[-3.051,3.051]],"o":[[3.051,-3.051],[3.051,3.051],[0,0],[-3.051,3.051],[-3.051,-3.051],[0,0]],"v":[[-2.062,-9.706],[8.987,-9.706],[8.987,1.343],[-12.613,22.942],[-23.661,22.942],[-23.661,11.894]],"c":true}]},{"t":296,"s":[{"i":[[0,0],[-12.639,-12.639],[12.639,-12.639],[0,0],[12.639,12.639],[-12.639,12.639]],"o":[[12.639,-12.639],[12.639,12.639],[0,0],[-12.639,12.639],[-12.639,-12.639],[0,0]],"v":[[-22.946,-20.876],[22.825,-20.876],[22.825,24.896],[22.952,24.943],[-22.82,24.943],[-22.82,-20.828]],"c":true}]}],"ix":2},"nm":"路径 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0.066666670144,0.945098102093,1,1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[0.674509823322,1,0.262745112181,1]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":280,"s":[0.674509823322,1,0.262745112181,1]},{"t":296,"s":[0.066666670144,0.945098102093,1,1]}],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-7.337,6.618],"ix":2},"a":{"a":0,"k":[-7.337,6.618],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"组 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[{"i":[[0,0],[12.639,-12.639],[-12.639,-12.639],[0,0],[-12.639,12.639],[12.639,12.639]],"o":[[-12.639,-12.639],[-12.639,12.639],[0,0],[12.639,12.639],[12.639,-12.639],[0,0]],"v":[[22.927,-20.835],[-22.844,-20.835],[-22.844,24.936],[-23.249,24.566],[22.523,24.566],[22.523,-21.205]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[0,0],[3.051,-3.051],[-3.051,-3.051],[0,0],[-3.051,3.051],[3.051,3.051]],"o":[[-3.051,-3.051],[-3.051,3.051],[0,0],[3.051,3.051],[3.051,-3.051],[0,0]],"v":[[-12.613,-9.706],[-23.661,-9.706],[-23.661,1.343],[-2.062,22.942],[8.987,22.942],[8.987,11.894]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[{"i":[[0,0],[3.051,-3.051],[-3.051,-3.051],[0,0],[-3.051,3.051],[3.051,3.051]],"o":[[-3.051,-3.051],[-3.051,3.051],[0,0],[3.051,3.051],[3.051,-3.051],[0,0]],"v":[[-12.613,-9.706],[-23.661,-9.706],[-23.661,1.343],[-2.062,22.942],[8.987,22.942],[8.987,11.894]],"c":true}]},{"t":296,"s":[{"i":[[0,0],[12.639,-12.639],[-12.639,-12.639],[0,0],[-12.639,12.639],[12.639,12.639]],"o":[[-12.639,-12.639],[-12.639,12.639],[0,0],[12.639,12.639],[12.639,-12.639],[0,0]],"v":[[22.927,-20.835],[-22.844,-20.835],[-22.844,24.936],[-23.249,24.566],[22.523,24.566],[22.523,-21.205]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0.066666670144,0.945098102093,1,1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[0.674509823322,1,0.262745112181,1]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":280,"s":[0.674509823322,1,0.262745112181,1]},{"t":296,"s":[0.066666670144,0.945098102093,1,1]}],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-7.337,6.618],"ix":2},"a":{"a":0,"k":[-7.337,6.618],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"组 1","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":239,"op":301,"st":252,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Round 2","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[0.054,2.176,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"t":260,"s":[-25,-5.824,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[-25,-5.824,0],"to":[0,0,0],"ti":[0,0,0]},{"t":296,"s":[0.054,2.176,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"高斯模糊","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"模糊度","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":7,"nm":"模糊方向","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"重复边缘像素","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":1,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[{"i":[[-17.977,0],[0,-17.977],[17.977,0],[0,17.977]],"o":[[17.977,0],[0,17.977],[-17.977,0],[0,-17.977]],"v":[[0,-32.551],[32.551,0],[0,32.551],[-32.551,0]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[-9.3,0],[0,-9.3],[9.3,0],[0,9.3]],"o":[[9.3,0],[0,9.3],[-9.3,0],[0,-9.3]],"v":[[1.223,-16.821],[18.062,0.018],[1.223,16.858],[-15.616,0.018]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[{"i":[[-9.3,0],[0,-9.3],[9.3,0],[0,9.3]],"o":[[9.3,0],[0,9.3],[-9.3,0],[0,-9.3]],"v":[[1.223,-16.821],[18.062,0.018],[1.223,16.858],[-15.616,0.018]],"c":true}]},{"t":296,"s":[{"i":[[-17.977,0],[0,-17.977],[17.977,0],[0,17.977]],"o":[[17.977,0],[0,17.977],[-17.977,0],[0,-17.977]],"v":[[0,-32.551],[32.551,0],[0,32.551],[-32.551,0]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0.066666670144,0.945098102093,1,1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[1,0.411764711142,0.301960796118,1]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":280,"s":[1,0.411764711142,0.301960796118,1]},{"t":296,"s":[0.066666670144,0.945098102093,1,1]}],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Round","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":239,"op":301,"st":239,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Rectangle 4106","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[-2.375,1.221,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"t":260,"s":[-23.125,38.229,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[-23.125,38.229,0],"to":[0,0,0],"ti":[0,0,0]},{"t":296,"s":[-2.375,1.221,0]}],"ix":2},"a":{"a":0,"k":[0,0.344,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":240,"s":[{"i":[[0,0],[0,-14.322],[0,0],[-21.813,0],[0,0],[0,21.023],[0,0],[25.265,0]],"o":[[-22.344,0],[0,0],[0,15.373],[0,0],[16.9,0],[0,0],[0,-12.533],[0,0]],"v":[[2.218,-31.127],[-30.615,1.097],[-30.615,1.097],[2.218,33.815],[2.142,33.815],[35.24,1.097],[35.24,1.097],[2.142,-31.127]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[0,0],[0,-3.257],[0,0],[-3.33,0],[0,0],[0,3.363],[0,0],[3.384,0]],"o":[[-3.338,0],[0,0],[0,3.274],[0,0],[3.253,0],[0,0],[0,-3.229],[0,0]],"v":[[-7.203,-18.011],[-13.127,-12.014],[-13.127,12.693],[-7.203,18.698],[7.218,18.698],[13.147,12.693],[13.147,-12.014],[7.218,-18.011]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":280,"s":[{"i":[[0,0],[0,-3.257],[0,0],[-3.33,0],[0,0],[0,3.363],[0,0],[3.384,0]],"o":[[-3.338,0],[0,0],[0,3.274],[0,0],[3.253,0],[0,0],[0,-3.229],[0,0]],"v":[[-7.203,-18.011],[-13.127,-12.014],[-13.127,12.693],[-7.203,18.698],[7.218,18.698],[13.147,12.693],[13.147,-12.014],[7.218,-18.011]],"c":true}]},{"t":296,"s":[{"i":[[0,0],[0,-14.322],[0,0],[-21.813,0],[0,0],[0,21.023],[0,0],[25.265,0]],"o":[[-22.344,0],[0,0],[0,15.373],[0,0],[16.9,0],[0,0],[0,-12.533],[0,0]],"v":[[2.218,-31.127],[-30.615,1.097],[-30.615,1.097],[2.218,33.815],[2.142,33.815],[35.24,1.097],[35.24,1.097],[2.142,-31.127]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":240,"s":[0.066666670144,0.945098102093,1,1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":260,"s":[0.988416671753,0.420833349228,1,1]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":280,"s":[0.988416671753,0.420833349228,1,1]},{"t":296,"s":[0.066666670144,0.945098102093,1,1]}],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":239,"op":302,"st":239,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Ellipse 1409","parent":6,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":179,"s":[0.057,0.075,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":209,"s":[-24.818,22.575,0],"to":[0,0,0],"ti":[0,0,0]},{"t":239,"s":[0.057,0.075,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.785,0],[0,-1.785],[1.785,0],[0,1.785]],"o":[[1.785,0],[0,1.785],[-1.785,0],[0,-1.785]],"v":[[0,-3.232],[3.232,0],[0,3.232],[-3.232,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1409","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":179,"op":239,"st":30,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Sector","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-0.226,-0.037,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":179,"s":[{"i":[[0,-0.942],[0,0],[23.198,0],[0,0],[0,8.126],[0,0],[0,0.961],[-0.001,0.103],[-17.911,0],[0,-20.991]],"o":[[0,0],[0,10.073],[0,0],[-25.602,0],[0,0],[0,-0.978],[0,-0.103],[0.149,-19.638],[17.163,0],[0,0.926]],"v":[[31.966,4.377],[31.96,4.39],[-0.349,34.629],[-0.358,34.566],[-33.086,4.337],[-33.072,4.327],[-32.999,3.647],[-32.998,3.338],[-0.591,-29.429],[31.837,3.704]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":209,"s":[{"i":[[0,-0.985],[0,0],[6.103,0],[0,0],[0,6.078],[0,0],[-0.078,0.961],[-0.01,0.109],[-18.738,0],[-1.495,-18.386]],"o":[[0,0],[0,6.078],[0,0],[-6.103,0],[0,0],[0,-0.981],[0.009,-0.11],[1.645,-18.236],[18.845,0],[0.078,0.965]],"v":[[35.914,2.626],[35.914,21.887],[24.864,32.893],[-24.864,32.893],[-35.914,21.887],[-35.914,2.626],[-35.797,-0.287],[-35.768,-0.615],[0,-33.143],[35.795,-0.3]],"c":true}]},{"t":239,"s":[{"i":[[0,-0.942],[0,0],[23.198,0],[0,0],[0,6.07],[0,0],[-0.07,0.958],[-0.009,0.109],[-17.028,0],[-1.298,-18.417]],"o":[[0,0],[0,6.597],[0,0],[-25.602,0],[0,0],[0,-0.978],[0.008,-0.11],[1.491,-18.213],[17.163,0],[0.065,0.923]],"v":[[33.841,4.377],[33.835,4.39],[1.526,34.629],[1.517,34.566],[-31.211,4.337],[-31.197,4.327],[-31.093,1.522],[-31.068,1.193],[1.279,-31.304],[33.743,1.579]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.066666662693,0.944000065327,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Sector","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":179,"op":239,"st":30,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Rectangle 4105","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":119,"s":[-0.287,-27.64,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":150,"s":[0,-23.243,0],"to":[0,0,0],"ti":[0,0,0]},{"t":179,"s":[-0.287,-27.64,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,-100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[4.7,4.099],[-0.036,-4.426],[-4.771,4.099]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"rd","nm":"圆角 1","r":{"a":0,"k":1,"ix":1},"ix":2,"mn":"ADBE Vector Filter - RC","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle 4105","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":119,"op":179,"st":30,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Rectangle 4104","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":119,"s":[-0.323,-36.087,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":150,"s":[0,-47.213,0],"to":[0,0,0],"ti":[0,0,0]},{"t":179,"s":[-0.323,-36.087,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[4.831,4.348],[0,-4.348],[-4.831,4.348]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"rd","nm":"圆角 1","r":{"a":0,"k":1,"ix":1},"ix":2,"mn":"ADBE Vector Filter - RC","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle 4104","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":119,"op":179,"st":30,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Vector 1315","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,-35.014,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":119,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,3.1],[0,3.65]],"c":false}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":150,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,8.413],[0,-8.413]],"c":false}]},{"t":179,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0,3.1],[0,3.65]],"c":false}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Vector 1315","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":119,"op":179,"st":30,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Rectangle","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,-1.75,0],"ix":2},"a":{"a":0,"k":[0,0.344,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":119,"s":[{"i":[[0,0],[0,-13.728],[0,0],[-20.908,0],[0,0],[0,20.152],[0,0],[24.217,0]],"o":[[-21.417,0],[0,0],[0,14.736],[0,0],[16.199,0],[0,0],[0,-12.014],[0,0]],"v":[[0.222,-30.781],[-31.25,0.108],[-31.25,0.108],[0.222,31.469],[0.149,31.469],[31.875,0.108],[31.875,0.108],[0.149,-30.781]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":151,"s":[{"i":[[0,0],[0,-5.964],[0,0],[-5.874,0],[0,0],[0,5.964],[0,0],[5.874,0]],"o":[[-5.874,0],[0,0],[0,5.964],[0,0],[5.874,0],[0,0],[0,-5.964],[0,0]],"v":[[-14.182,-34.75],[-24.818,-23.952],[-24.818,24.639],[-14.182,35.438],[14.182,35.438],[24.818,24.639],[24.818,-23.952],[14.182,-34.75]],"c":true}]},{"t":179,"s":[{"i":[[0,0],[0,-13.728],[0,0],[-20.908,0],[0,0],[0,20.152],[0,0],[24.217,0]],"o":[[-21.417,0],[0,0],[0,14.736],[0,0],[16.199,0],[0,0],[0,-12.014],[0,0]],"v":[[0.222,-30.781],[-31.25,0.108],[-31.25,0.108],[0.222,31.469],[0.149,31.469],[31.875,0.108],[31.875,0.108],[0.149,-30.781]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988416671753,0.420833349228,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":119,"op":179,"st":3,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Ellipse 1417","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,3.673,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[22.715,23.837,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,-0.579,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.69,0],[0,-1.69],[1.69,0],[0,1.69]],"o":[[1.69,0],[0,1.69],[-1.69,0],[0,-1.69]],"v":[[0,-3.06],[3.06,0],[0,3.06],[-3.06,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1413","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Ellipse 1416","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,3.673,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[22.715,-21.874,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,-0.579,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.69,0],[0,-1.69],[1.69,0],[0,1.69]],"o":[[1.69,0],[0,1.69],[-1.69,0],[0,-1.69]],"v":[[0,-3.06],[3.06,0],[0,3.06],[-3.06,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1413","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Ellipse 1415","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,3.673,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[-22.995,-21.874,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,-0.579,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.69,0],[0,-1.69],[1.69,0],[0,1.69]],"o":[[1.69,0],[0,1.69],[-1.69,0],[0,-1.69]],"v":[[0,-3.06],[3.06,0],[0,3.06],[-3.06,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1413","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Ellipse 1413","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,3.673,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[-22.995,23.837,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,0.274,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.69,0],[0,-1.69],[1.69,0],[0,1.69]],"o":[[1.69,0],[0,1.69],[-1.69,0],[0,-1.69]],"v":[[0,-3.06],[3.06,0],[0,3.06],[-3.06,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1413","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Vector2","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,1.36,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[-0.035,1.36,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,1.36,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-0.035,-0.035],[0.035,0.035]],"c":false}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[22.855,22.855],[-22.855,-22.855]],"c":false}]},{"t":119,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-0.035,-0.035],[0.035,0.035]],"c":false}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Vector2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Vector1","parent":17,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[-0.035,1.36,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[-0.035,1.36,0],"to":[0,0,0],"ti":[0,0,0]},{"t":119,"s":[-0.035,1.36,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0.299,0.299],[-0.299,-0.299]],"c":false}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[22.855,22.855],[-22.855,-22.855]],"c":false}]},{"t":119,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0.299,0.299],[-0.299,-0.299]],"c":false}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Vector1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Vector","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":59,"s":[0]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":89,"s":[90]},{"t":119,"s":[180]}],"ix":10},"p":{"a":0,"k":[0.035,0.035,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[{"i":[[0,0],[12.639,-12.639],[-12.639,-12.639],[0,0],[-12.639,12.639],[12.639,12.639]],"o":[[-12.639,-12.639],[-12.639,12.639],[0,0],[12.639,12.639],[12.639,-12.639],[0,0]],"v":[[22.927,-20.835],[-22.844,-20.835],[-22.844,24.936],[-23.249,24.566],[22.523,24.566],[22.523,-21.205]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[{"i":[[0,0],[5.907,-5.907],[-5.907,-5.907],[0,0],[-5.907,5.907],[5.907,5.907]],"o":[[-5.907,-5.907],[-5.907,5.907],[0,0],[5.907,5.907],[5.907,-5.907],[0,0]],"v":[[-10.214,-31.605],[-31.605,-31.605],[-31.605,-10.214],[10.214,31.605],[31.605,31.605],[31.605,10.214]],"c":true}]},{"t":119,"s":[{"i":[[0,0],[12.737,-12.737],[-12.737,-12.737],[0,0],[-12.737,12.737],[12.737,12.737]],"o":[[-12.737,-12.737],[-12.737,12.737],[0,0],[12.737,12.737],[12.737,-12.737],[0,0]],"v":[[23.146,-20.907],[-22.978,-20.907],[-22.978,25.217],[-23.386,24.844],[22.738,24.844],[22.738,-21.28]],"c":true}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[{"i":[[0,0],[-12.639,-12.639],[12.639,-12.639],[0,0],[12.639,12.639],[-12.639,12.639]],"o":[[12.639,-12.639],[12.639,12.639],[0,0],[-12.639,12.639],[-12.639,-12.639],[0,0]],"v":[[-22.946,-20.876],[22.825,-20.876],[22.825,24.896],[22.952,24.943],[-22.82,24.943],[-22.82,-20.828]],"c":true}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[{"i":[[0,0],[-5.907,-5.907],[5.907,-5.907],[0,0],[5.907,5.907],[-5.907,5.907]],"o":[[5.907,-5.907],[5.907,5.907],[0,0],[-5.907,5.907],[-5.907,-5.907],[0,0]],"v":[[10.214,-31.605],[31.605,-31.605],[31.605,-10.214],[-10.214,31.605],[-31.605,31.605],[-31.605,10.214]],"c":true}]},{"t":119,"s":[{"i":[[0,0],[-12.639,-12.639],[12.639,-12.639],[0,0],[12.639,12.639],[-12.639,12.639]],"o":[[12.639,-12.639],[12.639,12.639],[0,0],[-12.639,12.639],[-12.639,-12.639],[0,0]],"v":[[-22.946,-20.876],[22.825,-20.876],[22.825,24.896],[22.952,24.943],[-22.82,24.943],[-22.82,-20.828]],"c":true}]}],"ix":2},"nm":"路径 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":2,"nm":"合并路径 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.675500035286,1,0.262499988079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Vector","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":59,"op":119,"st":29,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"Ellipse 1404","parent":22,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-0.14,-33.231,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[4.206,4.206],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"椭圆路径 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Ellipse 1404","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":59,"st":-1,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"Vector 1314","parent":22,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,-33.091,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":-1,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0.054,0],[-0.054,0]],"c":false}]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":29,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[28.604,0],[-28.604,0]],"c":false}]},{"t":59,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[0.054,0],[-0.054,0]],"c":false}]}],"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Vector 1314","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":59,"st":-1,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"Rectangle 4101","parent":22,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":-1,"s":[0.604,-32.814,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":29,"s":[33.104,-32.814,0],"to":[0,0,0],"ti":[0,0,0]},{"t":59,"s":[0.604,-32.814,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[3.161,-2.919],[3.161,2.87],[-2.628,2.87],[-2.628,-2.919]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":-45,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle 4100","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":59,"st":-1,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"Rectangle 4100","parent":22,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":-1,"s":[0.854,-32.814,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":29,"s":[-31.646,-32.814,0],"to":[0,0,0],"ti":[0,0,0]},{"t":59,"s":[0.854,-32.814,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[3.161,-2.919],[3.161,2.87],[-2.628,2.87],[-2.628,-2.919]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":-45,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Rectangle 4100","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":59,"st":-1,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"Round","parent":23,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0],"y":[0]},"t":-1,"s":[-180]},{"i":{"x":[1],"y":[1]},"o":{"x":[1],"y":[0]},"t":29,"s":[0]},{"t":59,"s":[180]}],"ix":10},"p":{"a":0,"k":[0.054,2.176,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-17.977,0],[0,-17.977],[17.977,0],[0,17.977]],"o":[[17.977,0],[0,17.977],[-17.977,0],[0,-17.977]],"v":[[0,-32.551],[32.551,0],[0,32.551],[-32.551,0]],"c":true},"ix":2},"nm":"路径 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2.243,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"描边 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.411764711142,0.301960796118,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"填充 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"变换"}],"nm":"Round","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":59,"st":-1,"bm":0},{"ddd":0,"ind":23,"ty":3,"nm":"空 1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":-1,"s":[156,101.75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":29,"s":[156,67.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":59,"s":[156,101.75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":89,"s":[156,67.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":119,"s":[156,101.75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":150,"s":[156,67.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0,"y":1},"o":{"x":0,"y":0},"t":179,"s":[156,101.75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":209,"s":[156,67.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.077,"y":1},"o":{"x":0,"y":0},"t":239,"s":[156,101.75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":1,"y":1},"o":{"x":1,"y":0},"t":270,"s":[156,62.5,0],"to":[0,0,0],"ti":[0,0,0]},{"t":299,"s":[156,101.75,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":300,"st":0,"bm":0}],"markers":[]}');
// EXTERNAL MODULE: ./src/components/fetchLoading/views/index.tsx
var views = __webpack_require__(77139);
;// CONCATENATED MODULE: ./src/components/fetchLoading/views/pptCreateLoading.tsx




const PPTCreateLoading = /*#__PURE__*/ react.memo((param)=>{
    let { width  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views/* FetchLoading */.B, {
        animationData: pptCreateLoading_namespaceObject,
        width: width
    });
});
PPTCreateLoading.displayName = "PPTCreateLoading";

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/createPPTProgress/index.module.css
var createPPTProgress_index_module = __webpack_require__(48655);
var createPPTProgress_index_module_default = /*#__PURE__*/__webpack_require__.n(createPPTProgress_index_module);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 9 modules
var modal = __webpack_require__(15862);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/css.js
var modal_style_css = __webpack_require__(86898);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/createPPTProgress/index.tsx






const CreatePPTProgress = (props)=>{
    const { percent =0 , onClose  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        open: true,
        width: 360,
        closable: true,
        className: (createPPTProgress_index_module_default()).createPPTProgressModal,
        bodyStyle: {
            padding: 0
        },
        centered: true,
        footer: null,
        onCancel: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (createPPTProgress_index_module_default()).createPPTProgressContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PPTCreateLoading, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                    percent: percent,
                    strokeWidth: 3,
                    strokeColor: "#66A8FF",
                    showInfo: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (createPPTProgress_index_module_default()).createPPTProgressContentText,
                    children: [
                        "生成PPT中（已完成",
                        percent,
                        "%）"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (createPPTProgress_index_module_default()).createPPTProgressContentDes,
                    children: "DeepSeek R1 正在拼命思考..."
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/floatHelp/index.js + 8 modules
var floatHelp = __webpack_require__(11122);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/core/dist/core.esm.js + 1 modules
var core_esm = __webpack_require__(60887);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/sortable/dist/sortable.esm.js
var sortable_esm = __webpack_require__(45587);
// EXTERNAL MODULE: ./node_modules/@dnd-kit/utilities/dist/utilities.esm.js
var utilities_esm = __webpack_require__(24285);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/dragPage/Page.module.css
var Page_module = __webpack_require__(53415);
var Page_module_default = /*#__PURE__*/__webpack_require__.n(Page_module);
// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/dragPage/Markdown.module.css
var Markdown_module = __webpack_require__(61805);
var Markdown_module_default = /*#__PURE__*/__webpack_require__.n(Markdown_module);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/dragPage/Markdown.tsx







const Markdown = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { onChange , value , onBlur , onFocus , autoFocus  } = props;
    const editorRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            getEditor: ()=>{
                var ref;
                return (ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.editor();
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((Markdown_module_default()).mdEditorWrapper, {
                [(Markdown_module_default()).mdEditorWrapperSafari]: (0,utils/* isSafari */.G6)(),
                [(Markdown_module_default()).mdEditor]: true
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Scrollbars */.$B, {
                className: classnames_default()((Markdown_module_default()).mdEditorWrapper, {
                    [(Markdown_module_default()).mdEditorWrapperSafari]: (0,utils/* isSafari */.G6)()
                }),
                autoHide: true,
                autoHeight: true,
                autoHeightMax: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdownEditor, {
                    value: value,
                    onChange: onChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    placeholder: "请输入内容",
                    autoFocus: autoFocus
                })
            })
        })
    });
});
Markdown.displayName = "Markdown";
/* harmony default export */ const dragPage_Markdown = (/*#__PURE__*/react.memo(Markdown));

;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/dragPage/Page.tsx












var Position;
(function(Position) {
    Position[Position["Before"] = -1] = "Before";
    Position[Position["After"] = 1] = "After";
})(Position || (Position = {}));
const Page = /*#__PURE__*/ (0,react.forwardRef)(function Page(param, ref) {
    let { id , index , active , clone , insertPosition , onRemove , onAdd , onCopy , style , className , item , onMdChange , onMdBlur , onInputChange , onInputBlur , ...props } = param;
    const [focus, setFocus] = (0,react.useState)(false);
    const isComposing = (0,react.useRef)(false);
    const handleComposition = (e, type)=>{
        if (e.type === "compositionstart") {
            isComposing.current = true;
        }
        if (e.type === "compositionend") {
            isComposing.current = false;
            if (e.target instanceof HTMLInputElement) {
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(e.target.value, type);
            }
        }
    };
    const handleChange = (e, type)=>{
        if (!isComposing.current) {
            onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(e.target.value, type);
        }
    };
    const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Page_module_default()).popoverContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: ()=>{
                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                        click_type: (item === null || item === void 0 ? void 0 : item.type) === "内容" ? "delete_page_main" : (item === null || item === void 0 ? void 0 : item.type) === "封面" ? "delete_page_cover" : "delete_page_final"
                    });
                    onRemove === null || onRemove === void 0 ? void 0 : onRemove();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        name: "TrashCan",
                        fontSize: 16
                    }),
                    "删除"
                ]
            }),
            (item === null || item === void 0 ? void 0 : item.type) === "内容" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: ()=>{
                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                        click_type: "add_page_more"
                    });
                    onAdd === null || onAdd === void 0 ? void 0 : onAdd();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        name: "PlusCircle",
                        fontSize: 16
                    }),
                    "新增"
                ]
            }),
            (item === null || item === void 0 ? void 0 : item.type) === "内容" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: ()=>{
                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                        click_type: "copy_page"
                    });
                    onCopy === null || onCopy === void 0 ? void 0 : onCopy();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        name: "Duplicate",
                        fontSize: 16
                    }),
                    "复制"
                ]
            })
        ]
    });
    const onMdFocus = ()=>{
        setFocus(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: classnames_default()((Page_module_default()).wrapper, (item === null || item === void 0 ? void 0 : item.type) !== "内容" && (Page_module_default()).fixed, active && (Page_module_default()).active, clone && (Page_module_default()).clone, insertPosition === Position.Before && (Page_module_default()).insertBefore, insertPosition === Position.After && (Page_module_default()).insertAfter, (item === null || item === void 0 ? void 0 : item.content) === "" && item.type === "内容" && (Page_module_default()).empty, focus && (Page_module_default()).focus, className),
        style: style,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Page_module_default()).page,
            "data-id": item === null || item === void 0 ? void 0 : item.id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Page_module_default()).dragIcon, {
                        [(Page_module_default()).dragIconVisible]: (item === null || item === void 0 ? void 0 : item.type) === "内容"
                    }),
                    ...(item === null || item === void 0 ? void 0 : item.type) === "内容" ? {
                        ...props
                    } : {},
                    children: (item === null || item === void 0 ? void 0 : item.type) === "内容" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                style: {
                                    cursor: (item === null || item === void 0 ? void 0 : item.type) === "内容" ? "grab" : "default",
                                    pointerEvents: (item === null || item === void 0 ? void 0 : item.type) === "内容" ? "auto" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "6",
                                        cy: "4",
                                        r: "1",
                                        fill: "#ABADB2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "10",
                                        cy: "4",
                                        r: "1",
                                        fill: "#ABADB2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "10",
                                        cy: "8",
                                        r: "1",
                                        fill: "#ABADB2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "10",
                                        cy: "12",
                                        r: "1",
                                        fill: "#ABADB2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "6",
                                        cy: "8",
                                        r: "1",
                                        fill: "#ABADB2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "6",
                                        cy: "12",
                                        r: "1",
                                        fill: "#ABADB2"
                                    })
                                ]
                            }),
                            index !== void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Page_module_default()).number,
                                children: index
                            }) : null
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Page_module_default()).tag,
                        style: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100%",
                            textAlign: "center"
                        },
                        children: (item === null || item === void 0 ? void 0 : item.type) === "封面" ? "封面" : "结语"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Page_module_default()).content,
                    children: (item === null || item === void 0 ? void 0 : item.type) === "内容" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dragPage_Markdown, {
                        value: markdownHelper.md.render((item === null || item === void 0 ? void 0 : item.content) || ""),
                        onChange: onMdChange,
                        autoFocus: index === 1,
                        onBlur: ()=>{
                            setFocus(false);
                            onMdBlur === null || onMdBlur === void 0 ? void 0 : onMdBlur();
                        },
                        onFocus: onMdFocus
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Page_module_default()).contentOther,
                        children: (item === null || item === void 0 ? void 0 : item.type) === "封面" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                            defaultValue: item === null || item === void 0 ? void 0 : item.title,
                            autoFocus: true,
                            onChange: (e)=>handleChange(e, "title"),
                            onCompositionStart: (e)=>handleComposition(e, "title"),
                            onCompositionEnd: (e)=>handleComposition(e, "title"),
                            onBlur: ()=>{
                                onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur();
                                setFocus(false);
                            },
                            onFocus: onMdFocus
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                            defaultValue: item === null || item === void 0 ? void 0 : item.content,
                            onChange: (e)=>handleChange(e, "end"),
                            onCompositionStart: (e)=>handleComposition(e, "end"),
                            onCompositionEnd: (e)=>handleComposition(e, "end"),
                            onBlur: ()=>{
                                onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur();
                                setFocus(false);
                            },
                            onFocus: onMdFocus
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
                    content: content,
                    placement: "bottomLeft",
                    showArrow: false,
                    overlayClassName: (Page_module_default()).popover,
                    align: {
                        offset: [
                            0,
                            -6
                        ]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Page_module_default()).action,
                        children: "..."
                    })
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./src/pageComponents/webWorkbench/components/dragPage/index.module.css
var dragPage_index_module = __webpack_require__(65901);
var dragPage_index_module_default = /*#__PURE__*/__webpack_require__.n(dragPage_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/dragPage/utils/index.ts
// 判断是否触发合并的条件
function shouldMergeByDirection(active, over, activeIndex, overIndex) {
    var ref, ref1;
    if (!active || !over || active.id === over.id) return false;
    const activeRect = (ref = active.rect) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.translated;
    const overRect = over.rect;
    // 如果没有矩形信息则返回false
    if (!activeRect || !overRect) return false;
    // 计算拖动元素与目标元素的垂直重叠
    const activeTop = activeRect.top;
    const overTop = overRect.top;
    const activeBottom = activeRect.bottom;
    const overBottom = overRect.bottom;
    // console.log(`Active top: ${activeTop}, Over top: ${overTop}`);
    // 如果是activeIndex > overIndex,则代表是从下往上拖动
    // 如果是activeIndex < overIndex,则代表是从上往下拖动
    // 从下往上拖动，判断activeTop是否大于overTop，是的话，则满足合并条件，否则就是排序
    // 从上往下拖动，判断activeTop是否小于overTop，是的话，则满足合并条件，否则就是排序
    if (activeIndex > overIndex && activeTop > overTop) {
        return true;
    }
    if (activeIndex < overIndex && activeTop < overTop) {
        return true;
    }
    return false; // 不满足合并条件
}
// 判断是否可以排序
function canSortByDirection(active, over, activeIndex, overIndex) {
    var ref, ref1;
    if (!active || !over || active.id === over.id) return false;
    const activeRect = (ref = active.rect) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.translated;
    const overRect = over.rect;
    // 如果没有矩形信息则返回false
    if (!activeRect || !overRect) return false;
    // 计算拖动元素与目标元素的垂直重叠
    const activeTop = activeRect.top;
    const overTop = overRect.top;
    // console.log(`Active top: ${activeTop}, Over top: ${overTop}`);
    // 如果是activeIndex > overIndex,则代表是从下往上拖动
    // 如果是activeIndex < overIndex,则代表是从上往下拖动
    // 从下往上拖动，判断activeTop是否大于overTop，是的话，则满足合并条件，否则就是排序
    // 从上往下拖动，判断activeTop是否小于overTop，是的话，则满足合并条件，否则就是排序
    if (activeIndex > overIndex && activeTop < overTop) {
        return true;
    }
    if (activeIndex < overIndex && activeTop > overTop) {
        return true;
    }
    return false; // 不满足合并条件
}
function getPageItemById(items, id) {
    return items.find((item)=>item.id === id);
}
function getPageItemIndexById(items, id) {
    return items.findIndex((item)=>item.id === id);
}

;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/components/dragPage/index.tsx















const measuring = {
    droppable: {
        strategy: core_esm/* MeasuringStrategy.Always */.uN.Always
    }
};
const dropAnimation = {
    keyframes (param) {
        let { transform  } = param;
        return [
            {
                transform: utilities_esm/* CSS.Transform.toString */.ux.Transform.toString(transform.initial)
            },
            {
                transform: utilities_esm/* CSS.Transform.toString */.ux.Transform.toString({
                    scaleX: 0.98,
                    scaleY: 0.98,
                    x: transform.final.x - 10,
                    y: transform.final.y - 10
                })
            }
        ];
    },
    sideEffects: (0,core_esm/* defaultDropAnimationSideEffects */.Ai)({
        className: {
            active: (Page_module_default()).active
        }
    })
};
function Pages(param) {
    let { items , onMergeItems , onRemoveItem , onAddItem , onCopyItem , onReorder , onMdChange , onMdBlur , onInputChange , onInputBlur  } = param;
    const [activeId, setActiveId] = (0,react.useState)(null);
    const [mergeTargetId, setMergeTargetId] = (0,react.useState)(null);
    const activeIndex = activeId != null ? getPageItemIndexById(items, activeId) : -1;
    // 是否可以排序
    const [canSort, setCanSort] = (0,react.useState)(false);
    // 鼠标点击位置
    const clickPosition = (0,react.useRef)(null);
    const isMouseDown = (0,react.useRef)(false);
    const sensors = (0,core_esm/* useSensors */.Dy)((0,core_esm/* useSensor */.VT)(core_esm/* PointerSensor */.we));
    function mergeItems(fromId, toId) {
        onMergeItems(fromId, toId);
    }
    // 实时判断是否合并
    const throttledHandleDragOver = (0,react.useMemo)(()=>{
        return (0,lodash.throttle)((param)=>{
            let { active , over  } = param;
            // console.log("【clickPosition】：", clickPosition.current, over, active);
            if (!over || active.id === over.id) {
                setMergeTargetId(null);
                return;
            }
            const activeIndex = getPageItemIndexById(items, active.id);
            const overIndex = getPageItemIndexById(items, over.id);
            const overItem = items[overIndex];
            if (overItem.type === "封面" || overItem.type === "致谢") {
                setMergeTargetId(null);
                setCanSort(false);
                return;
            }
            // 先判断是否可以合并
            const isToTop = activeIndex > overIndex;
            if (isToTop) {
                var ref;
                const overTop = over.rect.top + over.rect.height * (2 / 3);
                // 只要鼠标还在over的下方3/2处，就是合并
                if (((ref = clickPosition.current) === null || ref === void 0 ? void 0 : ref.y) && clickPosition.current.y > overTop) {
                    setMergeTargetId(over.id);
                    setCanSort(false);
                    return;
                } else {
                    setMergeTargetId(null);
                    setCanSort(true);
                    return;
                }
            } else {
                var ref1;
                const oveTop = over.rect.top + over.rect.height * (2 / 3);
                // 只要鼠标还在over的上方3/2处，就是合并
                if (((ref1 = clickPosition.current) === null || ref1 === void 0 ? void 0 : ref1.y) && clickPosition.current.y < oveTop) {
                    setMergeTargetId(over.id);
                    setCanSort(false);
                    return;
                } else {
                    setMergeTargetId(null);
                    setCanSort(true);
                    return;
                }
            }
        // const shouldMerge = shouldMergeByDirection(
        //   active,
        //   over,
        //   activeIndex,
        //   overIndex
        // );
        // const canSort = canSortByDirection(
        //   active,
        //   over,
        //   activeIndex,
        //   overIndex
        // );
        // setMergeTargetId(shouldMerge ? (over.id as string) : null);
        // setCanSort(canSort);
        }, 100);
    }, [
        items
    ]);
    function handleDragStart(param) {
        let { active  } = param;
        setActiveId(active.id);
    }
    function handleDragCancel() {
        setActiveId(null);
        setMergeTargetId(null);
    }
    // 处理拖动结束时的逻辑
    function handleDragEnd(param) {
        let { active , over  } = param;
        if (!over || !active.id || active.id === over.id) {
            setActiveId(null);
            setMergeTargetId(null);
            return;
        }
        if (mergeTargetId === over.id) {
            mergeItems(active.id, over.id);
            setActiveId(null);
            setMergeTargetId(null);
            return;
        }
        const activeIndex = getPageItemIndexById(items, active.id);
        const overIndex = getPageItemIndexById(items, over.id);
        if (activeIndex !== -1 && overIndex !== -1 && activeIndex !== overIndex) {
            // setItems((items) => arrayMove(items, activeIndex, overIndex));
            onReorder(items, activeIndex, overIndex);
        }
        setCanSort(false);
        setActiveId(null);
        setMergeTargetId(null);
    }
    const handleMouseDown = (e)=>{
        isMouseDown.current = true;
        clickPosition.current = {
            x: e.clientX,
            y: e.clientY
        };
    };
    const handleMouseUp = ()=>{
        isMouseDown.current = false;
        clickPosition.current = null;
    };
    const handleMouseMove = (e)=>{
        if (isMouseDown.current) {
            clickPosition.current = {
                x: e.clientX,
                y: e.clientY
            };
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("mouseup", handleMouseUp);
        document.addEventListener("mousemove", handleMouseMove);
        return ()=>{
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("mouseup", handleMouseUp);
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(core_esm/* DndContext */.LB, {
        onDragStart: handleDragStart,
        // onDragOver={handleDragOver}
        onDragMove: throttledHandleDragOver,
        onDragEnd: handleDragEnd,
        onDragCancel: handleDragCancel,
        sensors: sensors,
        collisionDetection: core_esm/* pointerWithin */.j2,
        measuring: measuring,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sortable_esm/* SortableContext */.Fo, {
                items: items,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (dragPage_index_module_default()).pages,
                    children: items.map((item, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortablePage, {
                                    id: item.id,
                                    item: item,
                                    index: (items === null || items === void 0 ? void 0 : items[0].type) === "封面" ? index : index + 1,
                                    activeIndex: activeIndex,
                                    canSort: canSort,
                                    mergeTargetId: mergeTargetId,
                                    onRemove: ()=>onRemoveItem(item.id),
                                    onAdd: ()=>onAddItem(item.id),
                                    onCopy: ()=>onCopyItem(item.id),
                                    onMdChange: (markdown, html, len)=>{
                                        return onMdChange === null || onMdChange === void 0 ? void 0 : onMdChange(item.id, markdown, html, len);
                                    },
                                    onMdBlur: ()=>{
                                        return onMdBlur === null || onMdBlur === void 0 ? void 0 : onMdBlur(item.id);
                                    },
                                    onInputChange: (value, type)=>{
                                        return onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(item.id, value, type);
                                    },
                                    onInputBlur: ()=>{
                                        return onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(item.id);
                                    }
                                }),
                                index !== items.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dragPage_index_module_default()).addButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (dragPage_index_module_default()).addButtonInner,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                            title: "添加卡片",
                                            placement: "top",
                                            showArrow: false,
                                            align: {
                                                offset: [
                                                    0,
                                                    6
                                                ]
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (dragPage_index_module_default()).addButtonWrap,
                                                onClick: ()=>{
                                                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                        click_type: "add_page_between"
                                                    });
                                                    onAddItem(item.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    name: "PlusBlack",
                                                    fontSize: 10,
                                                    color: "#fff"
                                                })
                                            })
                                        })
                                    })
                                }, "button-".concat(item.id))
                            ]
                        }, item.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_esm/* DragOverlay */.y9, {
                dropAnimation: dropAnimation,
                children: activeId != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageOverlay, {
                    id: activeId,
                    items: items
                }) : null
            })
        ]
    });
}
function PageOverlay(param) {
    let { id , items , ...props } = param;
    const activeItem = items.find((item)=>item.id === id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
        id: id,
        ...props,
        item: activeItem,
        clone: true,
        insertPosition: undefined
    });
}
function SortablePage(param) {
    let { id , activeIndex , mergeTargetId , canSort , item , ...props } = param;
    const { attributes , listeners , index , isDragging , isSorting , over , active , setNodeRef , transform , transition  } = (0,sortable_esm/* useSortable */.nB)({
        id,
        animateLayoutChanges: always
    });
    const isMergeTarget = id === mergeTargetId;
    const renderPage = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
            ref: setNodeRef,
            id: id,
            item: item,
            active: isDragging,
            className: classnames_default()({
                [(Page_module_default()).mergeTarget]: isMergeTarget
            }),
            style: {
                transition,
                transform: isSorting ? undefined : utilities_esm/* CSS.Translate.toString */.ux.Translate.toString(transform)
            },
            insertPosition: // 优先判断是否是合并目标
            mergeTargetId === id ? undefined : (over === null || over === void 0 ? void 0 : over.id) === id && canSort ? index > activeIndex ? Position.After : Position.Before : undefined,
            ...props,
            ...attributes,
            ...listeners
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
        title: "合并页面",
        placement: "left",
        open: isMergeTarget,
        children: renderPage()
    });
}
function always() {
    return true;
}
/* harmony default export */ const dragPage = (/*#__PURE__*/react.memo(Pages));

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 69 modules
var es_select = __webpack_require__(62702);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 10 modules
var input_number = __webpack_require__(6829);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/css.js + 1 modules
var select_style_css = __webpack_require__(83899);
// EXTERNAL MODULE: ./src/components/pageNumberSelect/index.module.css
var pageNumberSelect_index_module = __webpack_require__(97198);
var pageNumberSelect_index_module_default = /*#__PURE__*/__webpack_require__.n(pageNumberSelect_index_module);
;// CONCATENATED MODULE: ./src/components/pageNumberSelect/index.tsx











const { Option  } = es_select/* default */.Z;
const pageNumberSelect = [
    {
        name: "自动分页",
        value: "0"
    },
    {
        name: "1页",
        value: "1"
    },
    {
        name: "2页",
        value: "2"
    },
    {
        name: "3页",
        value: "3"
    },
    {
        name: "4页",
        value: "4"
    },
    {
        name: "5页",
        value: "5"
    }
];
const PageNumberSelect = (props)=>{
    const { value , onChange , style , placement ="bottomLeft" , customLabel =false , className ="" , theme ="light" , size ="middle"  } = props;
    const [open, setOpen] = (0,react.useState)(false);
    const getLabelFromValue = (val)=>{
        const found = pageNumberSelect.find((item)=>item.value === val);
        if (found) return "页数：".concat(found.name);
        return "页数：".concat(val, "页");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
        labelInValue: true,
        open: open,
        value: value ? {
            value,
            label: getLabelFromValue(value)
        } : undefined,
        onDropdownVisibleChange: (v)=>setOpen(v),
        onInputKeyDown: (e)=>{
            e.key === "Enter" && e.stopPropagation();
        },
        onChange: (selected)=>{
            const isOption = pageNumberSelect.some((item)=>item.value === selected.value);
            ;
            if (isOption) {
                onChange === null || onChange === void 0 ? void 0 : onChange(selected.value);
                setOpen(false);
            }
        },
        dropdownRender: (menu)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    menu,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            paddingLeft: 16
                        },
                        onMouseDown: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* default */.Z, {
                                id: "pageNumberInput",
                                bordered: false,
                                controls: false,
                                min: "0",
                                className: (pageNumberSelect_index_module_default()).pageNumberInput,
                                onKeyDown: (e)=>{
                                    e.stopPropagation();
                                },
                                value: value === "0" ? null : value,
                                style: {
                                    width: 30,
                                    borderBottom: "1px solid #38f",
                                    padding: 0
                                },
                                onChange: (val)=>{
                                    if (val && Number(val) > workbench/* MAX_PAGE_COUNT */.Ph) {
                                        (0,mtstat/* statTrack */.SF)("toast_show", {
                                            notification_type: "page_limit_notification",
                                            position: "aippt_home"
                                        });
                                        message/* default.error */.ZP.error("最多支持生成".concat(workbench/* MAX_PAGE_COUNT */.Ph, "页"));
                                        onChange === null || onChange === void 0 ? void 0 : onChange(workbench/* MAX_PAGE_COUNT.toString */.Ph.toString());
                                        return;
                                    }
                                    onChange === null || onChange === void 0 ? void 0 : onChange(val || "0");
                                }
                            }),
                            "页"
                        ]
                    })
                ]
            });
        },
        className: classnames_default()({
            [(pageNumberSelect_index_module_default()).pageSelect]: true,
            [(pageNumberSelect_index_module_default()).pageSelectOpen]: open,
            [className]: !!className,
            [(pageNumberSelect_index_module_default()).pageSelectDark]: theme === "dark"
        }),
        size: size,
        style: style,
        placement: placement,
        popupClassName: theme === "dark" ? (pageNumberSelect_index_module_default()).pageSelectDarkPopup : (pageNumberSelect_index_module_default()).pptBodyPageSelectPopup,
        optionLabelProp: "label",
        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            color: "#abadb2",
            fontSize: 12,
            name: open ? "ChevronUpBlack" : "ChevronDownBlack"
        }),
        children: pageNumberSelect.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
                value: item.value,
                label: customLabel ? "页数：".concat(item.name) : item.name,
                children: [
                    item.name,
                    value === item.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        style: {
                            marginLeft: 12
                        },
                        fontSize: 14,
                        color: "#38f",
                        name: "CheckBlack"
                    })
                ]
            }, item.value))
    });
};
/* harmony default export */ const components_pageNumberSelect = (/*#__PURE__*/react.memo(PageNumberSelect));

;// CONCATENATED MODULE: ./src/assets/images/aiDeepen.png
/* harmony default export */ const aiDeepen = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/aiDeepen.4abd461f.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAp0lEQVR42mOQlpHzk5GR6wHStUBcB2LLyMobMQABkGZlAAp2ArG0rLQ+I1RQGahol7SMvD0DCMiAdEnL8jJAAUgxUKxCRkZ+IVBREEigHohFZBSUYCbIQK3MBSroBCloZUACQEFeoNhqIK4CslMZgKqzQIqAdCEQhwHZaUCJ+UB6HhBrQnTJyscCBV8D8RcZiO52IO5jQAZC0qpMQAX+QImpQLwA5gsAd8Ek0a4nU0kAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/edit.png
/* harmony default export */ const edit = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/edit.f7d1cd4a.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAs0lEQVR42jWPsQ7CMAxEM8DeCUriJEgwAAsgdWslBAtInSqk8gdsfERB8APMzPCZPJcS6RSf7+xLjB7xYSAScidh3nLxCXzWijQn4EHj7CQW1oeR8+ENfzo1UdQIZWd2iA38Qv2xEhIDqUTi3trQV1F8XCI21vv0H3HEsOHO2PbCdKUWUICFGmqEXWfO0rH0tNY3gVx/sGbqRtRWN4EDxhLc6Q27mLiicZJfXKVbGZoaY8wXQTgiBh9dv+0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/ppt.png
/* harmony default export */ const ppt = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/ppt.f5077bbb.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAArElEQVR42i2PwQqBURCF7zNIlHvunZJQ1l7AA1gqfyhFJGVl6V+RZ7CxtvFWVl6Cb/hvfZ0758w0TfAn5RSVe0rWUcqdKFRZEAJBASeKBbp2+G/dg8Ibzkw00RHBTcmGgJ8aeNeAuYMHvOAZUy4JJjCnPnrDnuIek30kezM9wJvBPFYNl5asxpoVxhjCj5jr+q+wgk8JU4IlekA37nlWnWmJ3X20C20/FZVk4Qt+fCmoS+CijgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/pageComponents/webWorkbench/index.tsx



















































const PromotionComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9710), __webpack_require__.e(8815)]).then(__webpack_require__.bind(__webpack_require__, 55055)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(55055)
            ]
    },
    ssr: false
});
const OverseasAccessModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4943), __webpack_require__.e(8103)]).then(__webpack_require__.bind(__webpack_require__, 4943)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4943)
            ]
    },
    ssr: false
});
const Disclaimer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5181).then(__webpack_require__.bind(__webpack_require__, 35181)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35181)
            ]
    },
    ssr: false
});
const WIDHT = 224;
const GAP = 20;
const DEFAULT_COL = 4;
const TEXT_MAP = {
    [workbench/* StepType.outline */.WU.outline]: {
        title: "大纲生成",
        desc: "轻松编辑大纲，或保持原样继续"
    },
    [workbench/* StepType.template */.WU.template]: {
        title: "模板选择",
        desc: "选择您心仪的PPT模板进行完整PPT的生成"
    },
    [workbench/* StepType.page */.WU.page]: {
        title: "按页生成",
        desc: "根据每张卡片内容生成PPT，支持拖拽移动合并、增删和修改内容"
    },
    [workbench/* StepType.ppt */.WU.ppt]: {
        title: "",
        desc: ""
    },
    [workbench/* StepType.write */.WU.write]: {
        title: "",
        desc: ""
    }
};
const WebWorkbench = (props)=>{
    const { isPersonal  } = props;
    const { isWriteStep , activeTab , setActiveTab , chancelUpload , timer , setLoading , isDeepSeek , setIsDeepSeek , isInAWord , pageSizeSelect , activePageSize , setActivePageSize , keyword , keywordChangeHandle , placeholder , enterHandle , freeCreate , recommendClick , activeRecommendIndex , recommendPromptList , isPasteText , mdRef , richTextLen , richText , richTextChange , visibleTooltip , mdHtml , isImportFile , loading , importFileData , generateHandle , isOutlineStep , isTemplateStep , step , scrollRef , streamEnd , streamStr , treeData , outlineEnd , onDeleteTree , isPreset , lenSelect , activeLen , setActiveLen , generateTypeSelect , activeGenerateType , setActiveGenerateType , pptLoading , createAiPPT , onPresetStreamTypedComplete , onAddTree , treeInputChange , tagSelect , activeTag , setActiveTag , activeTemplate , templateList , setActiveTemplate , handleErrorMessage , createPPTLoading , createPPTPercent , cancelCreatePPT , handleNext , back , onOutlineBlur , isPageStep , pageItems , setPageItems , pageHistorySet , pageHistoryState , pageNumber , setPageNumber , showPageNumber  } = (0,usePPTGenerate/* default */.Z)();
    const [footerTabs, setFooterTabs] = (0,react.useState)([]);
    const [activeFooterTab, setActiveFooterTab] = (0,react.useState)();
    const userInfo = (0,useUserHelper/* useGetUserInfo */.Jh)();
    const [col, setCol] = (0,react.useState)(DEFAULT_COL);
    const [totalWidth, setTotalWidth] = (0,react.useState)(WIDHT * DEFAULT_COL + GAP * (DEFAULT_COL - 1));
    const query = (0,utils_query/* getQuery */.pm)();
    const clickAble = (0,react.useRef)(true);
    const pageTipsRef = (0,react.useRef)(null);
    const computerCol = ()=>{
        // 根据屏幕宽度 1. 小于1024 4列 -出现横向滚动 2. 1024～1279 4列 3. 1280～1439 4列 4. 1440 ～ 1679 5列 5 1680～ 1919 6列 6. 1920～ 2159 7列 7. 大于等于 2160 8列
        // 计算列数
        const col = window.innerWidth < 375 ? 2 : window.innerWidth < 1024 ? 4 : window.innerWidth < 1280 ? 4 : window.innerWidth < 1440 ? 4 : window.innerWidth < 1680 ? 5 : window.innerWidth < 1920 ? 6 : window.innerWidth < 2160 ? 7 : 8;
        setCol(col);
    };
    // 防抖监听窗口变化
    const debounceResize = (0,lodash.debounce)(computerCol, 100);
    (0,react.useEffect)(()=>{
        computerCol();
        window.addEventListener("resize", ()=>debounceResize());
        return ()=>{
            window.removeEventListener("resize", ()=>debounceResize());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(()=>{
        // 根据列数，宽度，间距计算出总的宽度
        const totalWidth = WIDHT * col + GAP * (col - 1);
        setTotalWidth(totalWidth);
    }, [
        col
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        const arr = !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) ? workbench/* FOOTER_TABS.filter */.$p.filter((v)=>!v.forceLogin) : workbench/* FOOTER_TABS */.$p;
        setFooterTabs(arr);
        setActiveFooterTab(arr === null || arr === void 0 ? void 0 : (ref = arr[0]) === null || ref === void 0 ? void 0 : ref.key);
    }, [
        userInfo
    ]);
    const recordClick = async (item)=>{
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "ppt_record"
        });
        const url = "".concat((0,constants/* getDesignHome */.y$)(), "/design");
        window.open("".concat(url, "?id=").concat(item.id, "&type=record&from=").concat((query === null || query === void 0 ? void 0 : query.from) || "record", "&origin=ai-ppt"));
    };
    const onCreate = ()=>{
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "create_blank_template"
        });
        const url = "".concat((0,constants/* getDesignHome */.y$)(), "/design");
        window.open("".concat(url, "?create=241&createEmptyPoster=true&width=1920&height=1080&unit=px&from=design_now_left&modeId=0&pick_id=2130&extraInfo=%257B%2522bg%2522%253A%257B%2522backgroundColor%2522%253A%2522%2523ffffffff%2522%257D%257D&isPPT=true"));
    };
    const fileUploadCallback = async (file, type)=>{
        if (chancelUpload.current) {
            clearTimeout(timer.current);
            return;
        }
        if (type === "pdf" || type === "ppt" || type === "pptx") {
            clearTimeout(timer.current);
            await generateHandle(file, {
                otherParams: {
                    type: 6,
                    file_type: type
                },
                isUpload: true,
                showProcessModal: false,
                forceLogin: false,
                toEdit: false
            });
        } else {
            importFileData.current = file;
            freeCreate({});
        }
    };
    const refresh = ()=>{
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "recreate_outline_bottom"
        });
        freeCreate({
            is_recreate: "1"
        });
    };
    const onReorder = (list, activeIndex, overIndex)=>{
        if (overIndex === 0 && list[0].type === "封面" || overIndex === list.length - 1 && list[list.length - 1].type === "致谢") {
            return;
        }
        pageHistorySet((0,sortable_esm/* arrayMove */.Rp)(pageItems, activeIndex, overIndex));
        setPageItems((items)=>(0,sortable_esm/* arrayMove */.Rp)(items, activeIndex, overIndex));
    };
    const onMerge = (fromId, toId)=>{
        ;
        const fromIndex = getPageItemIndexById(pageItems, fromId);
        const toIndex = getPageItemIndexById(pageItems, toId);
        const fromItem = pageItems[fromIndex];
        const toItem = pageItems[toIndex];
        if (toIndex === 0 && toItem.type === "封面" || toIndex === pageItems.length - 1 && toItem.type === "致谢") {
            return;
        }
        // index 小的排在前面
        const mergedContent = fromIndex < toIndex ? "".concat(fromItem.content, "\n").concat(toItem.content) : "".concat(toItem.content, "\n").concat(fromItem.content);
        const list = pageItems.map((item)=>{
            if (item.id === toId) {
                // 全新的ID，触发重新渲染
                return {
                    ...item,
                    id: (0,v4/* default */.Z)(),
                    content: mergedContent
                };
            }
            return item;
        }).filter((item)=>item.id !== fromId);
        pageHistorySet(list);
        setPageItems(list);
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "combine_page"
        });
    };
    const onRemove = (id)=>{
        if (pageItems.length <= workbench/* MIN_PAGE_COUNT */.NG) {
            message/* default.error */.ZP.error("卡片最少支持".concat(workbench/* MIN_PAGE_COUNT */.NG, "张"));
            return;
        }
        const list = pageItems.filter((item)=>item.id !== id);
        pageHistorySet(list);
        setPageItems(list);
    };
    const onAdd = (id)=>{
        if (pageItems.length >= workbench/* MAX_PAGE_COUNT */.Ph) {
            (0,mtstat/* statTrack */.SF)("toast_show", {
                notification_type: "page_limit_notification",
                position: "aippt_home_page_edit"
            });
            message/* default.error */.ZP.error("卡片最多支持".concat(workbench/* MAX_PAGE_COUNT */.Ph, "张"));
            return;
        }
        const index = pageItems.findIndex((item)=>item.id === id);
        // const item = pageItems[index];
        // 在index后插入一个新元素
        const list = [
            ...pageItems.slice(0, index + 1),
            {
                id: (0,v4/* default */.Z)(),
                content: "",
                type: "内容"
            },
            ...pageItems.slice(index + 1)
        ];
        pageHistorySet(list);
        setPageItems(list);
    };
    const onCopy = (id)=>{
        if (pageItems.length >= workbench/* MAX_PAGE_COUNT */.Ph) {
            message/* default.error */.ZP.error("卡片最多支持30张");
            return;
        }
        const index = pageItems.findIndex((item)=>item.id === id);
        const item = pageItems[index];
        const list = [
            ...pageItems.slice(0, index + 1),
            {
                id: (0,v4/* default */.Z)(),
                content: item.content,
                type: item.type
            },
            ...pageItems.slice(index + 1)
        ];
        pageHistorySet(list);
        setPageItems(list);
    };
    const onMdChange = (id, markdown)=>{
        setPageItems((items)=>items.map((item)=>{
                if (item.id === id) {
                    if (!markdown && markdown !== item.content) {
                        message/* default.error */.ZP.error("内容不能为空");
                    }
                    return {
                        ...item,
                        content: markdown
                    };
                }
                return item;
            }));
    };
    const onMdBlur = (id)=>{
        const historyItem = pageHistoryState === null || pageHistoryState === void 0 ? void 0 : pageHistoryState.find((item)=>item.id === id);
        const currentItem = pageItems.find((item)=>item.id === id);
        if ((historyItem === null || historyItem === void 0 ? void 0 : historyItem.content) === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.content)) return;
        const list = pageItems.map((item)=>{
            if (item.id === id) {
                return {
                    ...item,
                    id: (0,v4/* default */.Z)()
                };
            }
            return item;
        });
        setPageItems(list);
        pageHistorySet(list);
    };
    const onInputChange = (id, value, type)=>{
        ;
        if (value.length > 20) {
            message/* default.error */.ZP.error("最多支持20个字");
        }
        setPageItems((items)=>items.map((item)=>{
                if (item.id === id) {
                    return type === "title" ? {
                        ...item,
                        [type]: value
                    } : {
                        ...item,
                        content: value
                    };
                }
                return item;
            }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: constants/* TITLE */.R
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: constants/* WORKBENCH_DESCRIPTION */.SR
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: constants/* WORKBENCH_KEYWORDS */.Z8
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://public.static.meitudata.com/x-design/domain/mark-domain.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()({
                    [(index_module_default()).webWorkbench]: true,
                    [(index_module_default()).noWriteStep]: !isWriteStep
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(webHeader/* default */.Z, {
                        isPersonal: isPersonal,
                        onCreate: onCreate,
                        isWorkSpace: true
                    }),
                    isWriteStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (index_module_default()).tag,
                                        children: "LivePPT"
                                    }),
                                    "输入PPT主题",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "AI生成高质量PPT",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (index_module_default()).arrow,
                                        src: banner_arrow/* default */.Z,
                                        alt: "arrow",
                                        width: 63
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typeTabs, {
                                tabs: workbench/* TABS */.G7,
                                activeTab: activeTab,
                                setActiveTab: (v)=>{
                                    chancelUpload.current = true;
                                    clearTimeout(timer.current);
                                    setActiveTab(v);
                                    setTimeout(()=>{
                                        setLoading(false);
                                    }, 200);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((index_module_default()).inner, " ").concat((index_module_default()).isInAWordInner),
                                style: {
                                    display: isInAWord ? "flex" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).setting,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(deepSeekBtn["default"], {
                                                active: isDeepSeek,
                                                onClick: setIsDeepSeek,
                                                type: "card"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pageSelect/* default */.Z, {
                                                pageSizeSelect: pageSizeSelect,
                                                activePageSize: activePageSize,
                                                customLabel: true,
                                                onChange: setActivePageSize,
                                                className: (index_module_default()).webPageSelect
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(inAWordContent, {
                                        keyword: keyword,
                                        keywordChangeHandle: keywordChangeHandle,
                                        placeholder: placeholder,
                                        enterHandle: enterHandle,
                                        onCreate: ()=>{
                                            freeCreate({
                                                is_recreate: "0"
                                            });
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).inner,
                                style: {
                                    display: isPasteText ? "flex" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).setting,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_pageNumberSelect, {
                                                value: pageNumber.toString(),
                                                customLabel: true,
                                                onChange: (v)=>{
                                                    setPageNumber(~~v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).tips,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        fontSize: 12,
                                                        name: "InfoCircle",
                                                        style: {
                                                            marginRight: 4
                                                        }
                                                    }),
                                                    "您的内容已加密，仅用于本次AI生成后自动删除"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mdEditor, {
                                        ref: mdRef,
                                        onBlur: ()=>{
                                            (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                click_type: "paste_text",
                                                paste_text_words_number: richTextLen,
                                                // 只要markdown出现有序列表，就认为是有序列表
                                                paste_text_way: richText.includes("1.") ? "ordered_text" : "disordered_text"
                                            });
                                        },
                                        visibleTooltip: visibleTooltip,
                                        onChange: richTextChange,
                                        value: mdHtml,
                                        disabled: isPasteText ? richTextLen === 0 : false,
                                        onClick: ()=>freeCreate({
                                                is_recreate: "0"
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).inner,
                                style: {
                                    display: isImportFile ? "flex" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).setting,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_pageNumberSelect, {
                                                value: pageNumber.toString(),
                                                customLabel: true,
                                                onChange: (v)=>{
                                                    setPageNumber(~~v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).tips,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        fontSize: 12,
                                                        name: "InfoCircle",
                                                        style: {
                                                            marginRight: 4
                                                        }
                                                    }),
                                                    "您的内容已加密，仅用于本次AI生成后自动删除"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(importFile, {
                                        loading: loading,
                                        chancelUpload: chancelUpload,
                                        onClose: ()=>{
                                            clearTimeout(timer.current);
                                            importFileData.current = "";
                                        },
                                        setLoading: setLoading,
                                        uploadFile: (file, type)=>{
                                            fileUploadCallback(file, type);
                                        },
                                        toPasteText: ()=>{
                                            setActiveTab(workbench/* TabKey.pasteText */.Rc.pasteText);
                                        }
                                    })
                                ]
                            }),
                            isInAWord && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_try, {
                                keyword: keyword,
                                recommendClick: recommendClick,
                                activeRecommendIndex: activeRecommendIndex,
                                recommendPromptList: recommendPromptList
                            })
                        ]
                    }),
                    isWriteStep && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).footer,
                                style: {
                                    width: totalWidth
                                },
                                children: footerTabs.map((v)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()({
                                            [(index_module_default()).footerItem]: true,
                                            [(index_module_default()).footerItemActive]: activeFooterTab === v.key
                                        }),
                                        onClick: ()=>{
                                            if (v.key === activeFooterTab) return;
                                            v.key === workbench/* FooterTabKey.template */.M4.template && (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                click_type: "ppt_template_tab"
                                            });
                                            setActiveFooterTab(v.key);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: v.title
                                        })
                                    }, v.key);
                                })
                            }),
                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) && activeFooterTab === workbench/* FooterTabKey.record */.M4.record ? /*#__PURE__*/ (0,jsx_runtime.jsx)(record, {
                                col: col,
                                gap: GAP,
                                width: WIDHT,
                                totalWidth: totalWidth,
                                userInfo: userInfo,
                                onRecordClick: recordClick
                            }) : null,
                            activeFooterTab === workbench/* FooterTabKey.template */.M4.template ? /*#__PURE__*/ (0,jsx_runtime.jsx)(templates, {
                                col: col,
                                gap: GAP,
                                width: WIDHT,
                                totalWidth: totalWidth
                            }) : null
                        ]
                    }),
                    (isOutlineStep || isTemplateStep || isPageStep) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).secondContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).back,
                                onClick: back,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    fontSize: 16,
                                    name: "ChevronLeftBlack"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((index_module_default()).treeWrap, {
                                    [(index_module_default()).treeWrapPage]: isPageStep
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).desc,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: TEXT_MAP[step].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    TEXT_MAP[step].desc,
                                                    isPageStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
                                                        placement: "rightTop",
                                                        align: {
                                                            offset: [
                                                                0,
                                                                -18
                                                            ]
                                                        },
                                                        onOpenChange: (v)=>{
                                                            if (!window.localStorage.getItem("pageTips") && !v) {
                                                                window.localStorage.setItem("pageTips", "true");
                                                            }
                                                        },
                                                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (index_module_default()).pageTipsContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                    name: "CrossBlack",
                                                                    fontSize: 12,
                                                                    color: "#939599",
                                                                    className: (index_module_default()).pageTipsContentClose,
                                                                    onClick: ()=>{
                                                                        var // 关闭弹窗
                                                                        ref;
                                                                        (ref = pageTipsRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (index_module_default()).pageTipsContentTitle,
                                                                    children: "提示"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (index_module_default()).pageTipsContentList,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (index_module_default()).pageTipsContentListItem,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemTitle,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: aiDeepen,
                                                                                            alt: "tipsIcon1",
                                                                                            width: 14,
                                                                                            height: 14
                                                                                        }),
                                                                                        "逐页生成"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemDesc,
                                                                                    children: "按照每张卡片内容逐页生成PPT，您可确认下每张卡片内容"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (index_module_default()).pageTipsContentListItem,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemTitle,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: edit,
                                                                                            alt: "tipsIcon2",
                                                                                            width: 14,
                                                                                            height: 14
                                                                                        }),
                                                                                        "编辑卡片"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemDesc,
                                                                                    children: "拖拽卡片可移动和合并，可直接增删卡片和修改卡片内容"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (index_module_default()).pageTipsContentListItem,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemTitle,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: ppt,
                                                                                            alt: "tipsIcon3",
                                                                                            width: 14,
                                                                                            height: 14
                                                                                        }),
                                                                                        "草稿变PPT"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (index_module_default()).pageTipsContentListItemDesc,
                                                                                    children: "从您的笔记或草稿摇身一变高级PPT"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        trigger: "click",
                                                        defaultOpen: window.localStorage.getItem("pageTips") !== "true",
                                                        overlayClassName: (index_module_default()).pageTipsPopover,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (index_module_default()).pageTips,
                                                            ref: pageTipsRef,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                fontSize: 12,
                                                                name: "QuestionMarkCircle"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (isOutlineStep || isPageStep) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()({
                                            [(index_module_default()).tree]: true,
                                            [(index_module_default()).pageTree]: isPageStep && !loading,
                                            [(index_module_default()).pageTreeLoading]: isPageStep && loading
                                        }),
                                        children: [
                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).loading,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        textAlign: "center",
                                                        flex: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pptOutlineLoading/* PPTOutlineLoading */.M, {
                                                            width: 96,
                                                            style: {
                                                                margin: "0 auto"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (index_module_default()).loadingText,
                                                            children: isDeepSeek && isOutlineStep ? "DeepSeek R1 正在拼命思考中…" : isPageStep ? "AI自动分页中..." : "小美正在构思中，请稍等..."
                                                        })
                                                    ]
                                                })
                                            }),
                                            !loading && // @ts-ignore
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                                ref: scrollRef,
                                                autoHide: true,
                                                className: (index_module_default()).scroll,
                                                style: {
                                                    borderRadius: isPageStep && !loading ? 0 : 24
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        padding: isPageStep && !loading ? "1px 0 25px 0" : "20px 24px 20px 24px"
                                                    },
                                                    children: isPageStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dragPage, {
                                                        onReorder: onReorder,
                                                        onMergeItems: onMerge,
                                                        onRemoveItem: onRemove,
                                                        onAddItem: onAdd,
                                                        onCopyItem: onCopy,
                                                        onMdChange: onMdChange,
                                                        onInputChange: onInputChange,
                                                        onInputBlur: onMdBlur,
                                                        items: pageItems,
                                                        onMdBlur: onMdBlur
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            streamEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(outlineTree/* default */.Z, {
                                                                treeData: treeData,
                                                                onChange: treeInputChange,
                                                                onDeleteTree: onDeleteTree,
                                                                onAddTree: onAddTree,
                                                                onBlur: onOutlineBlur
                                                            }),
                                                            !streamEnd && !isPreset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (index_module_default()).stream,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: streamStr
                                                                }
                                                            }),
                                                            !streamEnd && isPreset && /*#__PURE__*/ (0,jsx_runtime.jsx)(typed/* default */.Z, {
                                                                domStr: streamStr,
                                                                className: "stream",
                                                                onComplete: onPresetStreamTypedComplete
                                                            }),
                                                            !outlineEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(pptOutlineLoading/* PPTOutlineLoading */.M, {
                                                                width: 48,
                                                                style: {
                                                                    margin: "0 auto"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isTemplateStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(templateSelect, {
                                        tagSelect: tagSelect,
                                        activeTag: activeTag,
                                        setActiveTag: setActiveTag,
                                        activeTemplate: activeTemplate,
                                        templateList: templateList,
                                        setActiveTemplate: setActiveTemplate,
                                        handleErrorMessage: handleErrorMessage,
                                        onGen: ()=>createAiPPT()
                                    }),
                                    (isOutlineStep || isWriteStep || isPageStep) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).outlineTag,
                                        children: [
                                            activeTab === workbench/* TabKey.inAWord */.Rc.inAWord && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tagSelect, {
                                                list: lenSelect,
                                                active: activeLen,
                                                config: {
                                                    label: "name",
                                                    value: "value"
                                                },
                                                title: "PPT文字内容",
                                                onTagSelect: (v)=>{
                                                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                        click_type: "words_number"
                                                    });
                                                    setActiveLen(v);
                                                }
                                            }),
                                            (activeTab === workbench/* TabKey.pasteText */.Rc.pasteText || activeTab === workbench/* TabKey.importFile */.Rc.importFile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tagSelect, {
                                                list: generateTypeSelect,
                                                active: activeGenerateType,
                                                config: {
                                                    label: "name",
                                                    value: "value",
                                                    desc: "desc",
                                                    icon: "icon"
                                                },
                                                title: "PPT文本内容",
                                                onTagSelect: (v)=>{
                                                    (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                        click_type: "words_number"
                                                    });
                                                    setActiveGenerateType(v);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (isOutlineStep || isPageStep) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).buttons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                        className: (index_module_default()).refresh,
                                        onClick: refresh,
                                        children: "重新生成"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_button/* default */.Z, {
                                        disabled: isPageStep ? loading || !pageItems.length : pptLoading || loading || !outlineEnd || !treeData.length,
                                        className: (index_module_default()).next,
                                        type: "primary",
                                        onClick: ()=>{
                                            if (!clickAble.current) return;
                                            clickAble.current = false;
                                            setTimeout(()=>{
                                                clickAble.current = true;
                                            }, 2000);
                                            handleNext();
                                        },
                                        children: [
                                            "选择模板",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: next_arrow,
                                                alt: "",
                                                style: {
                                                    marginLeft: 8,
                                                    width: 16,
                                                    height: 13
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionComponent, {
                        triggerPage: 8192
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasAccessModal, {
                        track: mtstat/* statTrack */.SF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatHelp/* default */.Z, {
                        userInfo: userInfo,
                        projectName: "海报编辑",
                        isShowCommunity: false,
                        hideBusiness: false,
                        size: "small"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).disclaimer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer, {
                            placement: "top",
                            direction: "row"
                        })
                    }),
                    createPPTLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePPTProgress, {
                        percent: createPPTPercent,
                        onClose: cancelCreatePPT
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const webWorkbench = (/*#__PURE__*/react.memo(WebWorkbench));


/***/ }),

/***/ 97198:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"pageSelect":"pageNumberSelect_pageSelect__FHNW5","pageSelectOpen":"pageNumberSelect_pageSelectOpen__S1Fi4","pptBodyPageSelectPopup":"pageNumberSelect_pptBodyPageSelectPopup__N7mCx","free":"pageNumberSelect_free__fKDjE","pageSelectDark":"pageNumberSelect_pageSelectDark__8kInJ","pageSelectDarkPopup":"pageNumberSelect_pageSelectDarkPopup__vfcJD","pageNumberInput":"pageNumberSelect_pageNumberInput__N0Yb0"};

/***/ }),

/***/ 4047:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"webHeader":"webHeader_webHeader__0R3uA","left":"webHeader_left__obtKs","right":"webHeader_right__y3Hed","createBtn":"webHeader_createBtn__FILei","createIcon":"webHeader_createIcon__nfGnP"};

/***/ }),

/***/ 48655:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"createPPTProgressModal":"createPPTProgress_createPPTProgressModal__t4noi","createPPTProgressContent":"createPPTProgress_createPPTProgressContent__DXaM3","createPPTProgressContentText":"createPPTProgress_createPPTProgressContentText__YPX2c","createPPTProgressContentDes":"createPPTProgress_createPPTProgressContentDes__xkPJ0"};

/***/ }),

/***/ 61805:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"mdEditor":"Markdown_mdEditor__T2fTE","mdEditorWrapper":"Markdown_mdEditorWrapper__OPI5U","mdEditorWrapperSafari":"Markdown_mdEditorWrapperSafari__P2y1I"};

/***/ }),

/***/ 53415:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__hMuFU","empty":"Page_empty__Y_9vD","page":"Page_page__8GEVw","active":"Page_active__SPGkY","focus":"Page_focus__hrE1N","dragIcon":"Page_dragIcon__2xUlS","clone":"Page_clone__4dGV_","pop":"Page_pop__5wxTE","remove":"Page_remove__X9GJw","fixed":"Page_fixed__194_L","insertBefore":"Page_insertBefore__4E2gQ","insertAfter":"Page_insertAfter__jskph","dragIconVisible":"Page_dragIconVisible__szA_M","content":"Page_content__iz0R0","contentOther":"Page_contentOther__cMaE9","action":"Page_action__vFyeW","popover":"Page_popover___Eqos","popoverContent":"Page_popoverContent__j2Pit","mergeTarget":"Page_mergeTarget___KS88","fadeIn":"Page_fadeIn__MfAtt"};

/***/ }),

/***/ 65901:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"pages":"dragPage_pages__XokWn","addButton":"dragPage_addButton__HMTXV","addButtonInner":"dragPage_addButtonInner__mhg8N","addButtonWrap":"dragPage_addButtonWrap__RQDYM"};

/***/ }),

/***/ 2558:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"import":"importFile_import__mnpli","importContent":"importFile_importContent__5KV4B","importButton":"importFile_importButton__3Xk6O","afreshButton":"importFile_afreshButton__8Er7c","importMessage":"importFile_importMessage__lA4ef"};

/***/ }),

/***/ 78994:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"input":"inAWordContent_input__ASQ25","inputContent":"inAWordContent_inputContent__taEY_","word":"inAWordContent_word__EhiZY"};

/***/ }),

/***/ 91767:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"mdEditor":"mdEditor_mdEditor__FAK0w","mdEditorWrapper":"mdEditor_mdEditorWrapper__EmozJ","mdEditorWrapperSafari":"mdEditor_mdEditorWrapperSafari__vnM_K","lenInfo":"mdEditor_lenInfo__Y87KZ","lenInfoError":"mdEditor_lenInfoError__NYbY_"};

/***/ }),

/***/ 31532:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"webProgress":"progress_webProgress___wAQe","webProgressText":"progress_webProgressText__sq4Ql","webProgressFile":"progress_webProgressFile__hPZSA","fileClose":"progress_fileClose__RHWFv"};

/***/ }),

/***/ 38770:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"pptRecord":"record_pptRecord__Acvwt","pptRecordTitle":"record_pptRecordTitle__ksaYh","pptRecordList":"record_pptRecordList__UGwTa","pptRecordListItem":"record_pptRecordListItem__YBhp_","pptRecordListItemPreview":"record_pptRecordListItemPreview__V8V7K","pptRecordListItemName":"record_pptRecordListItemName__w9Qu7","pptRecordListItemTag":"record_pptRecordListItemTag__gOJ_6","pptRecordListItemIcon":"record_pptRecordListItemIcon__SAvNo","pptRecordLoad":"record_pptRecordLoad__NWtjD","pptRecordLoadMore":"record_pptRecordLoadMore__bSDWU"};

/***/ }),

/***/ 71085:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"tagSelect":"tagSelect_tagSelect__NWg_X","tagSelectTitle":"tagSelect_tagSelectTitle__w22Ls","tagSelectList":"tagSelect_tagSelectList__38qw_","tagListAction":"tagSelect_tagListAction__bZcCU","actionIcon":"tagSelect_actionIcon__pXcd8","tagSelectScroll":"tagSelect_tagSelectScroll__kkXQw","actionLeft":"tagSelect_actionLeft__MODE0","actionRight":"tagSelect_actionRight__0xRn9","tagSelectItem":"tagSelect_tagSelectItem__WAzSA","newIcon":"tagSelect_newIcon__4fr3f","active":"tagSelect_active__Xbm6I"};

/***/ }),

/***/ 46867:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"templateSelect":"templateSelect_templateSelect__klUa_","templateList":"templateSelect_templateList__WnaWK","templateListScroll":"templateSelect_templateListScroll__h7cOm","templateItem":"templateSelect_templateItem__CUX_v","img":"templateSelect_img__MsK0l","newTagIcon":"templateSelect_newTagIcon__brxZD","templateItemActive":"templateSelect_templateItemActive__AHpj9","buttons":"templateSelect_buttons__Z1HGK","createButton":"templateSelect_createButton__l_BWY","templateItemPopoverOverlay":"templateSelect_templateItemPopoverOverlay___NYGv","templateItemPopover":"templateSelect_templateItemPopover__NxZSs"};

/***/ }),

/***/ 22984:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"templatesWrap":"templates_templatesWrap__4pbDb","templatesList":"templates_templatesList__dQ8BX","templatesLoad":"templates_templatesLoad__z5i8v","templatesListLoading":"templates_templatesListLoading__qAKQM","templatesListItem":"templates_templatesListItem__qW8Ew","templatesLoadMore":"templates_templatesLoadMore__cqnRe"};

/***/ }),

/***/ 11083:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"try":"try_try__85U9G","title":"try_title__int3f","recommends":"try_recommends__5H1h_","recommend":"try_recommend__uuL4D","active":"try_active__1jo6s"};

/***/ }),

/***/ 77448:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"typeTabs_tabs__UWVW3","item":"typeTabs_item__cGIkY","name":"typeTabs_name__FYMdQ","tag":"typeTabs_tag__VZNzA","active":"typeTabs_active__DE1fb"};

/***/ }),

/***/ 73352:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"webWorkbench":"webWorkbench_webWorkbench__WpdOb","noWriteStep":"webWorkbench_noWriteStep__scEE0","title":"webWorkbench_title__qnehs","tag":"webWorkbench_tag__TljBx","arrow":"webWorkbench_arrow__mMoVF","content":"webWorkbench_content__R6Svn","inner":"webWorkbench_inner__hQrqn","isInAWordInner":"webWorkbench_isInAWordInner__s7K3E","setting":"webWorkbench_setting__7I8fr","tips":"webWorkbench_tips__Ma7Sc","webPageSelect":"webWorkbench_webPageSelect__t7u4N","ant-select-selector":"webWorkbench_ant-select-selector__naO7B","disclaimer":"webWorkbench_disclaimer__1YgDt","footer":"webWorkbench_footer__pDo0i","footerItem":"webWorkbench_footerItem___FpDA","footerItemActive":"webWorkbench_footerItemActive__I2XBL","secondContent":"webWorkbench_secondContent__dAcKx","back":"webWorkbench_back__V1GIG","treeWrap":"webWorkbench_treeWrap__ux1Y7","treeWrapPage":"webWorkbench_treeWrapPage__43rCS","outlineTag":"webWorkbench_outlineTag__E37eT","desc":"webWorkbench_desc__7D_Yz","pageTips":"webWorkbench_pageTips__oMiMm","loading":"webWorkbench_loading__XVLQU","loadingText":"webWorkbench_loadingText__yCVVd","scroll":"webWorkbench_scroll__HfdyW","tree":"webWorkbench_tree__shtgy","pageTree":"webWorkbench_pageTree__XsFrI","pageTreeLoading":"webWorkbench_pageTreeLoading__MQA0Y","buttons":"webWorkbench_buttons__eFiYV","stream":"webWorkbench_stream__oLrIX","pageTipsPopover":"webWorkbench_pageTipsPopover__jX7tJ","pageTipsContent":"webWorkbench_pageTipsContent__dKQvZ","pageTipsContentList":"webWorkbench_pageTipsContentList__SJkms","pageTipsContentTitle":"webWorkbench_pageTipsContentTitle__l3_ib","pageTipsContentListItem":"webWorkbench_pageTipsContentListItem__inVWp","pageTipsContentListItemTitle":"webWorkbench_pageTipsContentListItemTitle__BwnuF","pageTipsContentListItemDesc":"webWorkbench_pageTipsContentListItemDesc__OQKlJ","pageTipsContentClose":"webWorkbench_pageTipsContentClose__gocVp"};

/***/ })

}]);